(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8940],{

/***/ 95383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34855);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1393);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32393);
/* harmony import */ var _util_hooks_useMergeValue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15955);
/* harmony import */ var _Select_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13549);
/* harmony import */ var _Select_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55074);
/* harmony import */ var _util_keycode__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85660);
/* harmony import */ var _util_omit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50049);
/* harmony import */ var _util_pick__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9472);
/* harmony import */ var _icon_react_icon_IconLoading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69049);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92833);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var IMPOSSIBLE_VALUE = "Autocomplete_" + Math.random();
var Option = _Select_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Option */ .Z.Option;
var defaultProps = {
    defaultActiveFirstOption: true,
    triggerElement: react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null),
};
function AutoComplete(baseProps, ref) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_3__/* .ConfigContext */ .E_), getPrefixCls = _a.getPrefixCls, componentConfig = _a.componentConfig;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.AutoComplete);
    var style = props.style, className = props.className, children = props.children, data = props.data, defaultValue = props.defaultValue, propValue = props.value, placeholder = props.placeholder, error = props.error, disabled = props.disabled, strict = props.strict, allowClear = props.allowClear, loading = props.loading, defaultActiveFirstOption = props.defaultActiveFirstOption, triggerElement = props.triggerElement, getPopupContainer = props.getPopupContainer, dropdownRender = props.dropdownRender, virtualListProps = props.virtualListProps, onFocus = props.onFocus, onBlur = props.onBlur, onChange = props.onChange, onSearch = props.onSearch, onSelect = props.onSelect, onPressEnter = props.onPressEnter, inputProps = props.inputProps;
    var _b = __read((0,_util_hooks_useMergeValue__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('', {
        defaultValue: defaultValue,
        value: propValue,
    }), 2), value = _b[0], setValue = _b[1];
    var _c = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isFocused = _c[0], setIsFocused = _c[1];
    var refInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var refSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var prefixCls = getPrefixCls('autocomplete');
    var filterOption = 'filterOption' in props
        ? props.filterOption
        : function (inputValue, option) {
            if (strict) {
                return option.props.value.indexOf(inputValue) > -1;
            }
            return option.props.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        };
    var childNodes = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    var selectChildren = null;
    if (childNodes.length && ((0,_Select_utils__WEBPACK_IMPORTED_MODULE_6__/* .isSelectOption */ .qf)(childNodes[0]) || (0,_Select_utils__WEBPACK_IMPORTED_MODULE_6__/* .isSelectOptGroup */ .kE)(childNodes[0]))) {
        selectChildren = children;
    }
    else if (data && data.length) {
        selectChildren = data.map(function (item, index) {
            if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(item)) {
                return item;
            }
            if (typeof item === 'string') {
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, { key: index, value: item }, item));
            }
            if (typeof item === 'object') {
                var _a = item, value_1 = _a.value, name_1 = _a.name;
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, { key: index, value: value_1, extra: (0,_util_omit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(item, ['value', 'name']) }, name_1));
            }
            return null;
        });
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () { return refInput.current; });
    var usedTriggerElement = typeof triggerElement === 'function' ? triggerElement({ value: value }) : triggerElement;
    var TriggerElement = react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(usedTriggerElement, __assign(__assign(__assign({ ref: function (node) {
            refInput.current = node;
            var originRef = usedTriggerElement.ref;
            if (typeof originRef === 'function') {
                originRef(node);
            }
        }, className: (0,_util_classNames__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("" + prefixCls, inputProps && inputProps.className, className), style: style, value: value, placeholder: placeholder, error: error, status: props.status, disabled: disabled, allowClear: allowClear }, inputProps), (0,_util_pick__WEBPACK_IMPORTED_MODULE_9__/* .pickDataAttributes */ .m)(props)), { 
        // Empty tag to ensure the consistency of the dom structure of input, such that input won't accidentally lose focus due to structure change on input.
        suffix: loading ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconLoading__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, null) : (inputProps === null || inputProps === void 0 ? void 0 : inputProps.suffix) || react__WEBPACK_IMPORTED_MODULE_0__.createElement("i", null), onFocus: function (event) {
            var _a;
            setIsFocused(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
            (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) === null || _a === void 0 ? void 0 : _a.call(inputProps, event);
        }, onBlur: function (event) {
            var _a;
            setIsFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(inputProps, event);
        }, onKeyDown: function (event) {
            var _a, _b, _c, _d, _e;
            var keyCode = event.keyCode || event.which;
            (_b = (_a = refSelect.current) === null || _a === void 0 ? void 0 : _a.hotkeyHandler) === null || _b === void 0 ? void 0 : _b.call(_a, event);
            if (keyCode === _util_keycode__WEBPACK_IMPORTED_MODULE_11__/* .Enter.code */ .Ce.code && onPressEnter) {
                var activeOption = void 0;
                if (refSelect.current) {
                    activeOption = refSelect.current.getOptionInfoByValue(refSelect.current.activeOptionValue);
                }
                onPressEnter(event, activeOption);
            }
            if (keyCode === _util_keycode__WEBPACK_IMPORTED_MODULE_11__/* .Esc.code */ .AV.code) {
                (_d = (_c = refInput.current) === null || _c === void 0 ? void 0 : _c.blur) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            (_e = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown) === null || _e === void 0 ? void 0 : _e.call(inputProps, event);
        }, onChange: function (value, event) {
            var _a;
            setValue(value);
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
            (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _a === void 0 ? void 0 : _a.call(inputProps, value, event);
        } }));
    var triggerProps = __assign(__assign({ popupVisible: !!(isFocused && ((data === null || data === void 0 ? void 0 : data.length) || react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children))) }, props.triggerProps), { 
        // Other trigger types are not supported yet
        trigger: 'focus', className: [prefixCls + "-popup"].concat(props.triggerProps && props.triggerProps.className) });
    var selectProps = {
        triggerElement: TriggerElement,
        // Guarantee that onChange can always be triggered
        value: IMPOSSIBLE_VALUE,
        inputValue: value,
        defaultActiveFirstOption: defaultActiveFirstOption,
        triggerProps: triggerProps,
        getPopupContainer: getPopupContainer,
        dropdownRender: dropdownRender,
        filterOption: filterOption,
        virtualListProps: virtualListProps,
        notFoundContent: null,
        onChange: function (value, option) {
            var _a, _b;
            setValue(value);
            onChange === null || onChange === void 0 ? void 0 : onChange(value, option);
            value && (onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, option));
            // Blur the input on option change
            (_b = (_a = refInput.current) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
        },
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Select_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __assign({ ref: refSelect }, selectProps), selectChildren));
}
var ForwardRefAutoComplete = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(AutoComplete);
var AutoCompleteComponent = ForwardRefAutoComplete;
AutoCompleteComponent.displayName = 'AutoComplete';
AutoCompleteComponent.Option = _Select_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Option */ .Z.Option;
AutoCompleteComponent.OptGroup = _Select_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OptGroup */ .Z.OptGroup;
/* harmony default export */ __webpack_exports__["Z"] = (AutoCompleteComponent);


/***/ }),

/***/ 56187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Button/group.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function Group(props, ref) {
    var className = props.className, style = props.style, children = props.children, rest = __rest(props, ["className", "style", "children"]);
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('btn-group');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, className);
    return (react.createElement("div", __assign({ ref: ref, className: classNames, style: style }, rest), children));
}
var GroupComponent = react.forwardRef(Group);
GroupComponent.displayName = 'ButtonGroup';
/* harmony default export */ var group = (GroupComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js
var Button_assign = (undefined && undefined.__assign) || function () {
    Button_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Button_assign.apply(this, arguments);
};
var Button_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var regexTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
function processChildren(children) {
    var childrenList = [];
    var isPrevChildPure = false;
    react.Children.forEach(children, function (child) {
        var isCurrentChildPure = typeof child === 'string' || typeof child === 'number';
        if (isCurrentChildPure && isPrevChildPure) {
            var lastIndex = childrenList.length - 1;
            var lastChild = childrenList[lastIndex];
            childrenList[lastIndex] = "" + lastChild + child;
        }
        else {
            childrenList.push(child);
        }
        isPrevChildPure = isCurrentChildPure;
    });
    return react.Children.map(childrenList, function (child) {
        return typeof child === 'string' ? react.createElement("span", null, child) : child;
    });
}
var defaultProps = {
    htmlType: 'button',
    type: 'default',
    shape: 'square',
};
function Button(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, ctxSize = _b.size, autoInsertSpaceInButton = _b.autoInsertSpaceInButton, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Button);
    var style = props.style, className = props.className, children = props.children, htmlType = props.htmlType, type = props.type, status = props.status, size = props.size, shape = props.shape, href = props.href, anchorProps = props.anchorProps, disabled = props.disabled, loading = props.loading, loadingFixedWidth = props.loadingFixedWidth, icon = props.icon, iconOnly = props.iconOnly, onClick = props.onClick, long = props.long, rest = Button_rest(props, ["style", "className", "children", "htmlType", "type", "status", "size", "shape", "href", "anchorProps", "disabled", "loading", "loadingFixedWidth", "icon", "iconOnly", "onClick", "long"]);
    var iconNode = loading ? react.createElement(IconLoading/* default */.Z, null) : icon;
    var _c = __read((0,react.useState)(false), 2), isTwoCNChar = _c[0], setIsTwoCNChar = _c[1];
    var innerButtonRef = (0,react.useRef)();
    var buttonRef = ref || innerButtonRef;
    (0,react.useEffect)(function () {
        if (autoInsertSpaceInButton && buttonRef && buttonRef.current) {
            var textContent = buttonRef.current.textContent;
            if (regexTwoCNChar.test(textContent)) {
                if (!isTwoCNChar) {
                    setIsTwoCNChar(true);
                }
            }
            else if (isTwoCNChar) {
                setIsTwoCNChar(false);
            }
        }
    }, [buttonRef.current, autoInsertSpaceInButton]);
    var prefixCls = getPrefixCls('btn');
    var _type = type === 'default' ? 'secondary' : type;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + _type, prefixCls + "-size-" + (size || ctxSize), prefixCls + "-shape-" + shape, (_a = {},
        _a[prefixCls + "-long"] = long,
        _a[prefixCls + "-status-" + status] = status,
        _a[prefixCls + "-loading-fixed-width"] = loadingFixedWidth,
        _a[prefixCls + "-loading"] = loading,
        _a[prefixCls + "-link"] = href,
        _a[prefixCls + "-icon-only"] = iconOnly || (!children && children !== 0 && iconNode),
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-two-chinese-chars"] = isTwoCNChar,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var handleClick = function (event) {
        if (loading || disabled) {
            typeof (event === null || event === void 0 ? void 0 : event.preventDefault) === 'function' && event.preventDefault();
            return;
        }
        onClick && onClick(event);
    };
    var InnerContent = (react.createElement(react.Fragment, null,
        iconNode,
        processChildren(children)));
    if (href) {
        var _anchorProps = Button_assign({}, anchorProps);
        if (disabled) {
            delete _anchorProps.href;
        }
        else {
            _anchorProps.href = href;
        }
        return (react.createElement("a", Button_assign({ ref: buttonRef }, rest, _anchorProps, { style: style, className: classNames, onClick: handleClick }), InnerContent));
    }
    return (react.createElement("button", Button_assign({ ref: buttonRef }, rest, { style: style, className: classNames, type: htmlType, disabled: disabled, onClick: handleClick }), InnerContent));
}
var ForwardRefButton = (0,react.forwardRef)(Button);
var ButtonComponent = ForwardRefButton;
ButtonComponent.__BYTE_BUTTON = true;
ButtonComponent.Group = group;
ButtonComponent.displayName = 'Button';
/* harmony default export */ var es_Button = (ButtonComponent);


/***/ }),

/***/ 54224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Checkbox; }
});

// UNUSED EXPORTS: ClearCheckboxGroupContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/constant.js
var constant = __webpack_require__(91702);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/group.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var defaultContextValue = {
    isCheckboxGroup: false,
    checkboxGroupValue: [],
    onGroupChange: function () { },
    registerValue: function () { },
    unRegisterValue: function () { },
};
var CheckboxGroupContext = (0,react.createContext)(defaultContextValue);
var ClearCheckboxGroupContext = function (_a) {
    var children = _a.children;
    return React.createElement(CheckboxGroupContext.Provider, { children: children, value: defaultContextValue });
};
function Group(props) {
    var _a;
    var _b = __read((0,useMergeValue/* default */.Z)([], {
        defaultValue: 'defaultValue' in props ? props.defaultValue || [] : undefined,
        value: 'value' in props ? props.value || [] : undefined,
    }), 2), value = _b[0], setValue = _b[1];
    var _c = __read((0,react.useState)([]), 2), allOptionValues = _c[0], setAllOptionValues = _c[1];
    var _d = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _d.getPrefixCls, rtl = _d.rtl;
    var disabled = props.disabled, options = props.options, style = props.style, className = props.className, error = props.error, children = props.children, _e = props.direction, direction = _e === void 0 ? 'horizontal' : _e;
    var prefixCls = getPrefixCls('checkbox');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-group", (_a = {},
        _a[prefixCls + "-group-is-error"] = error,
        _a[prefixCls + "-group-direction-" + direction] = direction,
        _a[prefixCls + "-group-rtl"] = rtl,
        _a), className);
    var onChange = (0,react.useCallback)(function (optionValue, checked, e) {
        var newVal = value.slice();
        if (checked) {
            newVal.push(optionValue);
        }
        else {
            newVal.splice(value.indexOf(optionValue), 1);
        }
        setValue(newVal);
        props.onChange &&
            props.onChange(newVal.filter(function (v) { return allOptionValues.indexOf(v) > -1; }), e);
    }, [value, props.onChange, allOptionValues]);
    return (react.createElement("span", __assign({ className: classNames, style: style }, (0,constant/* pickTriggerPropsFromRest */.Yy)(props)),
        react.createElement(CheckboxGroupContext.Provider, { value: {
                isCheckboxGroup: true,
                checkboxGroupValue: value,
                onGroupChange: onChange,
                disabled: disabled,
                registerValue: function (value) {
                    setAllOptionValues(function (allOptionValues) {
                        return Array.from(new Set(__spreadArray(__spreadArray([], __read(allOptionValues), false), [value], false)));
                    });
                },
                unRegisterValue: function (value) {
                    setAllOptionValues(function (allOptionValues) {
                        return allOptionValues.filter(function (x) { return x !== value; });
                    });
                },
            } }, (0,is/* isArray */.kJ)(options)
            ? options.map(function (option) {
                var label = (0,is/* isObject */.Kn)(option) ? option.label : option;
                var checkValue = (0,is/* isObject */.Kn)(option) ? option.value : option;
                var icon = (0,is/* isObject */.Kn)(option) ? option.icon : undefined;
                return (react.createElement(Checkbox_checkbox, { disabled: disabled || ((0,is/* isObject */.Kn)(option) && option.disabled), key: checkValue, value: checkValue, icon: icon }, label));
            })
            : children)));
}
Group.displayName = 'CheckboxGroup';
/* harmony default export */ var group = (Group);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/useCheckbox.js
var useCheckbox_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var useCheckbox_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


var useCheckbox = function (values, defaultSelected) {
    var _a = useCheckbox_read((0,react.useState)(useCheckbox_spreadArray([], useCheckbox_read((defaultSelected || [])), false)), 2), selected = _a[0], setSelected = _a[1];
    var _b = (0,react.useMemo)(function () {
        // 判断是否选中
        var isSelected = function (value) {
            return selected.indexOf(value) > -1;
        };
        // 设置选中
        var setValueSelected = function (value, selectStatus) {
            var list = (0,is/* isArray */.kJ)(value) ? value : [value];
            var newSelected;
            if (selectStatus) {
                newSelected = useCheckbox_spreadArray(useCheckbox_spreadArray([], useCheckbox_read(selected), false), useCheckbox_read(list), false);
            }
            else {
                newSelected = selected.filter(function (x) { return list.indexOf(x) === -1; });
            }
            setSelected(Array.from(new Set(newSelected)));
        };
        return {
            isSelected: isSelected,
            setValueSelected: setValueSelected,
        };
    }, [selected]), isSelected = _b.isSelected, setValueSelected = _b.setValueSelected;
    var _c = (0,react.useMemo)(function () {
        var selectAll = function () {
            setSelected(values);
        };
        var unSelectAll = function () {
            setSelected([]);
        };
        var toggle = function (value) {
            if (value === void 0) { value = values; }
            var list = (0,is/* isArray */.kJ)(value) ? value : [value];
            var newSelected = useCheckbox_spreadArray([], useCheckbox_read(selected), false);
            list.forEach(function (x) {
                var index = newSelected.indexOf(x);
                if (index > -1) {
                    newSelected.splice(index, 1);
                }
                else {
                    newSelected.push(x);
                }
            });
            setSelected(newSelected);
        };
        var isAllSelected = function () {
            return values.every(function (x) { return isSelected(x); });
        };
        /**
         * 是否部分选中
         */
        var isPartialSelected = function () {
            return values.some(function (x) { return isSelected(x); }) && !isAllSelected();
        };
        return {
            selectAll: selectAll,
            unSelectAll: unSelectAll,
            toggle: toggle,
            isAllSelected: isAllSelected,
            isPartialSelected: isPartialSelected,
        };
    }, [selected, values, isSelected]), selectAll = _c.selectAll, unSelectAll = _c.unSelectAll, toggle = _c.toggle, isAllSelected = _c.isAllSelected, isPartialSelected = _c.isPartialSelected;
    return {
        selected: selected,
        setSelected: setSelected,
        setValueSelected: setValueSelected,
        selectAll: selectAll,
        unSelectAll: unSelectAll,
        toggle: toggle,
        isSelected: isSelected,
        isAllSelected: isAllSelected,
        isPartialSelected: isPartialSelected,
    };
};
/* harmony default export */ var Checkbox_useCheckbox = (useCheckbox);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/icon-check.js

function IconCheck(_a) {
    var className = _a.className;
    return (react.createElement("svg", { className: className, "aria-hidden": true, focusable: false, viewBox: "0 0 1024 1024", width: "200", height: "200", fill: "currentColor" },
        react.createElement("path", { d: "M877.44815445 206.10060629a64.72691371 64.72691371 0 0 0-95.14856334 4.01306852L380.73381888 685.46812814 235.22771741 533.48933518a64.72691371 64.72691371 0 0 0-92.43003222-1.03563036l-45.82665557 45.82665443a64.72691371 64.72691371 0 0 0-0.90617629 90.61767965l239.61903446 250.10479331a64.72691371 64.72691371 0 0 0 71.19960405 15.14609778 64.33855261 64.33855261 0 0 0 35.08198741-21.23042702l36.24707186-42.71976334 40.5190474-40.77795556-3.36579926-3.49525333 411.40426297-486.74638962a64.72691371 64.72691371 0 0 0-3.88361443-87.64024149l-45.3088404-45.43829334z", "p-id": "840" })));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/checkbox.js
var checkbox_assign = (undefined && undefined.__assign) || function () {
    checkbox_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return checkbox_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var checkbox_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};











function Checkbox(baseProps, ref) {
    var _a;
    var inputRef = (0,react.useRef)(null);
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, {}, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Checkbox);
    var context = (0,react.useContext)(CheckboxGroupContext);
    var prefixCls = getPrefixCls('checkbox');
    var onGroupChange = context.onGroupChange;
    var mergeProps = checkbox_assign({}, props);
    if (context.isCheckboxGroup) {
        mergeProps.checked = context.checkboxGroupValue.indexOf(props.value) !== -1;
        mergeProps.disabled = 'disabled' in props ? props.disabled : context.disabled;
    }
    var disabled = mergeProps.disabled, children = mergeProps.children, className = mergeProps.className, value = mergeProps.value, style = mergeProps.style, indeterminate = mergeProps.indeterminate, error = mergeProps.error, rest = __rest(mergeProps, ["disabled", "children", "className", "value", "style", "indeterminate", "error"]);
    var _c = checkbox_read((0,useMergeValue/* default */.Z)(false, {
        value: mergeProps.checked,
        defaultValue: mergeProps.defaultChecked,
    }), 2), checked = _c[0], setChecked = _c[1];
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-disabled"] = !!disabled,
        _a[prefixCls + "-indeterminate"] = !!indeterminate,
        _a[prefixCls + "-checked"] = checked,
        _a[prefixCls + "-rtl"] = rtl,
        _a.error = error,
        _a), className);
    (0,react.useEffect)(function () {
        context.registerValue(value);
        return function () {
            context.unRegisterValue(value);
        };
    }, [value]);
    var onChange = (0,react.useCallback)(function (e) {
        e.persist();
        e.stopPropagation();
        setChecked(e.target.checked);
        if (context.isCheckboxGroup) {
            onGroupChange && onGroupChange(props.value, e.target.checked, e);
        }
        props.onChange && props.onChange(e.target.checked, e);
    }, [onGroupChange, context.isCheckboxGroup, props.onChange, props.value]);
    var onLabelClick = react.useCallback(function (e) {
        if ((0,is/* isFunction */.mf)(props.children)) {
            // 避免children中含有表单元素造成label无法触发input的onchange的情况
            e.preventDefault();
            inputRef.current && inputRef.current.click();
        }
        rest.onClick && rest.onClick(e);
    }, [props.children, rest.onClick]);
    var icon = react.createElement(IconCheck, { className: prefixCls + "-mask-icon" });
    if (mergeProps.icon) {
        if (react.isValidElement(mergeProps.icon)) {
            icon = react.cloneElement(mergeProps.icon, {
                className: prefixCls + "-mask-icon",
            });
        }
        else {
            icon = mergeProps.icon;
        }
    }
    return (react.createElement("label", checkbox_assign({ ref: ref, "aria-disabled": disabled }, (0,omit/* default */.Z)(rest, ['onChange']), { onClick: onLabelClick, className: classNames, style: style }),
        react.createElement("input", { value: value, disabled: !!disabled, ref: inputRef, checked: !!checked, onChange: onChange, 
            // To avoid triggering onChange twice in Select if it's used in Select option.
            onClick: function (e) { return e.stopPropagation(); }, type: "checkbox" }),
        (0,is/* isFunction */.mf)(children) ? (children({ checked: checked, indeterminate: indeterminate })) : (react.createElement(react.Fragment, null,
            react.createElement(icon_hover/* default */.Z, { prefix: prefixCls, className: prefixCls + "-mask-wrapper", disabled: checked || disabled || indeterminate },
                react.createElement("div", { className: prefixCls + "-mask" }, icon)),
            !(0,is/* isNullOrUndefined */.le)(children) && react.createElement("span", { className: prefixCls + "-text" }, children)))));
}
var CheckboxComponent = react.forwardRef(Checkbox);
CheckboxComponent.displayName = 'Checkbox';
CheckboxComponent.Group = group;
CheckboxComponent.useCheckbox = Checkbox_useCheckbox;
/* harmony default export */ var Checkbox_checkbox = (CheckboxComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/index.js

/* harmony default export */ var es_Checkbox = (Checkbox_checkbox);



/***/ }),

/***/ 32393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E_": function() { return /* binding */ ConfigContext; },
  "ZP": function() { return /* binding */ es_ConfigProvider; }
});

// UNUSED EXPORTS: ConfigConsumer

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/locale/default.js + 1 modules
var locale_default = __webpack_require__(64107);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/util.js
// Less lighten
function hexToRgb(hex) {
    var rgb = [];
    var _hex = hex.substr(1);
    // converts #abc to #aabbcc
    if (hex.length === 3) {
        _hex = hex.replace(/(.)/g, '$1$1');
    }
    _hex.replace(/../g, function (color) {
        rgb.push(parseInt(color, 0x10));
    });
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        rgb: "rgb(" + rgb.join(',') + ")",
    };
}
function getRgb(color) {
    var rgb = hexToRgb(color);
    return { r: rgb.r, g: rgb.g, b: rgb.b };
}
function getHsl(color) {
    var rgb = getRgb(color);
    var hsl = rgbToHsl(rgb.r, rgb.g, rgb.b);
    return { h: hsl.h, s: hsl.s, l: hsl.l };
}
function rgbToHsl(r, g, b) {
    var _r = r / 255;
    var _g = g / 255;
    var _b = b / 255;
    var max = Math.max(_r, _g, _b);
    var min = Math.min(_r, _g, _b);
    var l = (max + min) / 2;
    var h;
    var s;
    if (max === min) {
        h = 0;
        s = 0;
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case _r:
                h = (_g - _b) / d + (_g < _b ? 6 : 0);
                break;
            case _g:
                h = (_b - _r) / d + 2;
                break;
            case _b:
                h = (_r - _g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l,
        hsl: "hsl(" + h * 360 + ", " + s * 100 + "%, " + l * 100 + "%)",
    };
}
function lighten(color, percent) {
    var hsl = getHsl(color);
    var h = +hsl.h;
    var s = +hsl.s;
    var l = +hsl.l * 100 + +percent;
    // return `hsl(${h * 360}, ${s * 100}%, ${l}%)`;
    var res = hsltorgb([h * 360, s * 100, l]);
    return res.join(',');
}
// copy from https://github.com/Qix-/color-convert/blob/master/conversions.js
function hsltorgb(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t2;
    var t3;
    var val;
    if (s === 0) {
        val = l * 255;
        return [val, val, val];
    }
    if (l < 0.5) {
        t2 = l * (1 + s);
    }
    else {
        t2 = l + s - l * s;
    }
    var t1 = 2 * l - t2;
    var rgb = [0, 0, 0];
    for (var i = 0; i < 3; i++) {
        t3 = h + (1 / 3) * -(i - 1);
        if (t3 < 0) {
            t3++;
        }
        if (t3 > 1) {
            t3--;
        }
        if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
        }
        else if (2 * t3 < 1) {
            val = t2;
        }
        else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        }
        else {
            val = t1;
        }
        rgb[i] = val * 255;
    }
    return rgb;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Message/index.js + 1 modules
var Message = __webpack_require__(80507);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Notification/index.js + 1 modules
var Notification = __webpack_require__(34911);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Empty/index.js
var Empty = __webpack_require__(43061);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Modal/config.js
var Modal_config = __webpack_require__(91682);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/context.js
var context = __webpack_require__(4245);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};











var colorList = {
    primaryColor: {
        default: '--arcoblue-6',
        hover: '--arcoblue-5',
        active: '--arcoblue-7',
    },
    successColor: {
        default: '--green-6',
        hover: '--green-5',
        active: '--green-7',
    },
    infoColor: {
        default: '--arcoblue-6',
        hover: '--arcoblue-5',
        active: '--arcoblue-7',
    },
    warningColor: {
        default: '--orangered-6',
        hover: '--orangered-5',
        active: '--orangered-7',
    },
    dangerColor: {
        default: '--red-6',
        hover: '--red-5',
        active: '--red-7',
    },
};
function setTheme(theme) {
    if (theme && (0,is/* isObject */.Kn)(theme)) {
        var root_1 = document.body;
        Object.keys(colorList).forEach(function (color) {
            if (theme[color]) {
                root_1.style.setProperty(colorList[color].default, lighten(theme[color], 0));
                if (!theme[color + "Hover"]) {
                    root_1.style.setProperty(colorList[color].hover, lighten(theme[color], 10));
                }
                if (!theme[color + "Active"]) {
                    root_1.style.setProperty(colorList[color].active, lighten(theme[color], -10));
                }
            }
        });
    }
}
function renderEmpty(componentName) {
    switch (componentName) {
        default:
            return react.createElement(Empty/* default */.Z, null);
    }
}
var defaultProps = {
    locale: locale_default/* default */.Z,
    prefixCls: 'arco',
    getPopupContainer: function () { return document.body; },
    size: 'default',
    renderEmpty: renderEmpty,
    focusLock: {
        modal: { autoFocus: true },
        drawer: { autoFocus: true },
    },
};
var componentConfig = {};
var ConfigContext = (0,react.createContext)(__assign({ getPrefixCls: function (componentName, customPrefix) {
        return (customPrefix || 'arco') + "-" + componentName;
    } }, defaultProps));
function ConfigProvider(baseProps) {
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig);
    var theme = props.theme, prefixCls = props.prefixCls, children = props.children, locale = props.locale, rtl = props.rtl, _a = props.effectGlobalNotice, effectGlobalNotice = _a === void 0 ? true : _a;
    (0,react.useEffect)(function () {
        setTheme(theme);
    }, [theme]);
    (0,react.useEffect)(function () {
        if (effectGlobalNotice) {
            Message/* default.config */.Z.config({ prefixCls: prefixCls, rtl: rtl });
            Notification/* default.config */.Z.config({ prefixCls: prefixCls, rtl: rtl });
        }
    }, [prefixCls, rtl, effectGlobalNotice]);
    function getPrefixCls(componentName, customPrefix) {
        return (customPrefix || prefixCls) + "-" + componentName;
    }
    var config = __assign(__assign({}, (0,omit/* default */.Z)(props, ['children'])), { getPrefixCls: getPrefixCls });
    (0,react.useEffect)(function () {
        (0,Modal_config/* setConfigProviderProps */.t7)({ locale: locale, prefixCls: prefixCls, rtl: rtl });
    }, [locale, prefixCls]);
    var child = children;
    if (prefixCls && prefixCls !== 'arco') {
        child = react.createElement(context/* IconContext.Provider */.P.Provider, { value: { prefixCls: prefixCls } }, children);
    }
    return react.createElement(ConfigContext.Provider, { value: config }, child);
}
ConfigProvider.ConfigContext = ConfigContext;
ConfigProvider.displayName = 'ConfigProvider';
/* harmony default export */ var es_ConfigProvider = (ConfigProvider);
var ConfigConsumer = ConfigContext.Consumer;


/***/ }),

/***/ 43061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _icon_react_icon_IconEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93008);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34855);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32393);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92833);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





function Empty(baseProps, ref) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_), getPrefixCls = _a.getPrefixCls, globalLocale = _a.locale, componentConfig = _a.componentConfig;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps, {}, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Empty);
    var style = props.style, className = props.className, description = props.description, icon = props.icon, imgSrc = props.imgSrc, rest = __rest(props, ["style", "className", "description", "icon", "imgSrc"]);
    var prefixCls = getPrefixCls('empty');
    var classNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(prefixCls, className);
    var noData = globalLocale.Empty.noData;
    var alt = typeof description === 'string' ? description : 'empty';
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ ref: ref, className: classNames, style: style }, rest),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-wrapper" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-image" }, imgSrc ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { alt: alt, src: imgSrc }) : icon || react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconEmpty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-description" }, description || noData))));
}
var EmptyComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Empty);
EmptyComponent.displayName = 'Empty';
/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(EmptyComponent));


/***/ }),

/***/ 65808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53367);
/* harmony import */ var _util_hooks_useIsFirstRender__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91626);
/* harmony import */ var _util_hooks_useMergeValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15955);
/* harmony import */ var _image_preview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88765);
/* harmony import */ var _previewGroupContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83417);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






function PreviewGroup(props, ref) {
    var children = props.children, srcList = props.srcList, infinite = props.infinite, propCurrentIndex = props.current, defaultCurrent = props.defaultCurrent, onChange = props.onChange, propVisible = props.visible, defaultVisible = props.defaultVisible, onVisibleChange = props.onVisibleChange, restProps = __rest(props, ["children", "srcList", "infinite", "current", "defaultCurrent", "onChange", "visible", "defaultVisible", "onVisibleChange"]);
    var _a = __read((0,_util_hooks_useMergeValue__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false, {
        value: propVisible,
        defaultValue: defaultVisible,
    }), 2), visible = _a[0], setVisible = _a[1];
    var propPreviewUrlMap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (srcList ? new Map(srcList.map(function (url, index) { return [index, { url: url, preview: true }]; })) : null); }, [srcList]);
    var isFirstRender = (0,_util_hooks_useIsFirstRender__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var getPreviewUrlMap = function () { return (propPreviewUrlMap ? new Map(propPreviewUrlMap) : new Map()); };
    var _b = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getPreviewUrlMap()), 2), previewUrlMap = _b[0], setPreviewUrlMap = _b[1];
    var _c = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()), 2), previewPropsMap = _c[0], setPreviewPropsMap = _c[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isFirstRender)
            return;
        setPreviewUrlMap(getPreviewUrlMap());
    }, [propPreviewUrlMap]);
    var canPreviewUrlMap = new Map(Array.from(previewUrlMap)
        .filter(function (_a) {
        var _b = __read(_a, 2), preview = _b[1].preview;
        return preview;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), id = _b[0], url = _b[1].url;
        return [id, url];
    }));
    var _d = __read((0,_util_hooks_useMergeValue__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(0, {
        value: propCurrentIndex,
        defaultValue: defaultCurrent,
    }), 2), currentIndex = _d[0], setCurrentIndex = _d[1];
    function registerPreviewUrl(id, url, preview) {
        if (!propPreviewUrlMap) {
            setPreviewUrlMap(function (pre) {
                return new Map(pre).set(id, {
                    url: url,
                    preview: preview,
                });
            });
        }
        return function unRegisterPreviewUrl() {
            if (!propPreviewUrlMap) {
                setPreviewUrlMap(function (pre) {
                    var cloneMap = new Map(pre);
                    var hasDelete = cloneMap.delete(id);
                    return hasDelete ? cloneMap : pre;
                });
            }
        };
    }
    function registerPreviewProps(id, previewProps) {
        setPreviewPropsMap(function (pre) { return new Map(pre).set(id, (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(previewProps) ? previewProps : {}); });
        return function unRegisterPreviewProps() {
            setPreviewPropsMap(function (pre) {
                var cloneMap = new Map(pre);
                var hasDelete = cloneMap.delete(id);
                return hasDelete ? cloneMap : pre;
            });
        };
    }
    var refPreview = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () { return ({
        reset: function () {
            refPreview.current && refPreview.current.reset();
        },
    }); });
    var handleVisibleChange = function (newVisible, preVisible) {
        var _preVisible = (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isUndefined */ .o8)(preVisible) ? visible : preVisible;
        onVisibleChange && onVisibleChange(newVisible, _preVisible);
        setVisible(newVisible);
    };
    var handleSwitch = function (index) {
        onChange && onChange(index);
        setCurrentIndex(index);
    };
    var loopImageIndex = function (children) {
        var index = 0;
        var loop = function (children) {
            var result = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
                if (child && child.props && child.type) {
                    var displayName = child.type.displayName;
                    if (displayName === 'Image') {
                        return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, { _index: index++ });
                    }
                }
                if (child && child.props && child.props.children) {
                    return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
                        children: loop(child.props.children),
                    });
                }
                return child;
            });
            // 避免单个子节点 <div></div> 被处理为  [<div></div>] 格式
            if (!(0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .kJ)(children) && react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) === 1) {
                return result[0];
            }
            return result;
        };
        return loop(children);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_previewGroupContext__WEBPACK_IMPORTED_MODULE_4__/* .PreviewGroupContext.Provider */ .v.Provider, { value: {
            previewGroup: true,
            previewUrlMap: canPreviewUrlMap,
            previewPropsMap: previewPropsMap,
            infinite: infinite,
            currentIndex: currentIndex,
            setCurrentIndex: handleSwitch,
            setPreviewUrlMap: setPreviewUrlMap,
            registerPreviewUrl: registerPreviewUrl,
            registerPreviewProps: registerPreviewProps,
            visible: visible,
            handleVisibleChange: handleVisibleChange,
        } },
        loopImageIndex(children),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_image_preview__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, __assign({ ref: refPreview, src: "", visible: visible, onVisibleChange: handleVisibleChange }, restProps))));
}
var PreviewGroupComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(PreviewGroup);
PreviewGroupComponent.displayName = 'ImagePreviewGroup';
/* harmony default export */ __webpack_exports__["Z"] = (PreviewGroupComponent);


/***/ }),

/***/ 88765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ image_preview; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconZoomOut/index.js
var IconZoomOut = __webpack_require__(3249);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconZoomIn/index.js
var IconZoomIn = __webpack_require__(37081);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFullscreen/index.js
var IconFullscreen = __webpack_require__(42861);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRotateLeft/index.js
var IconRotateLeft = __webpack_require__(80241);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRotateRight/index.js
var IconRotateRight = __webpack_require__(86628);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconOriginalSize/index.js
var IconOriginalSize = __webpack_require__(63794);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/hooks/useImageStatus.js
var useImageStatus = __webpack_require__(83062);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/getScale.js

var defaultScales = [
    25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500,
];
var PreviewScales = /** @class */ (function () {
    function PreviewScales(scales) {
        this.updateScale(scales);
    }
    Object.defineProperty(PreviewScales.prototype, "scales", {
        get: function () {
            return this.scaleAttr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewScales.prototype, "minScale", {
        get: function () {
            return this.scaleAttr[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewScales.prototype, "maxScale", {
        get: function () {
            return this.scaleAttr[this.scaleAttr.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    PreviewScales.prototype.updateScale = function (scales) {
        var validScales = defaultScales;
        if ((0,is/* isArray */.kJ)(scales) && scales.filter(function (num) { return num > 0; }).length) {
            validScales = scales.filter(function (num) { return num > 0; });
        }
        validScales = validScales.map(function (num) { return +(num / 100).toFixed(2); });
        // 如果缩放比例中不含1， 则需要手动添加在最合适的位置
        if (!validScales.includes(1)) {
            var closestIndex = this.findClosestIndex(1, validScales);
            var closeSale = validScales[closestIndex];
            var addIndex = closeSale < 1 ? closestIndex + 1 : closestIndex;
            validScales.splice(addIndex, 0, 1);
        }
        this.scaleAttr = validScales;
    };
    PreviewScales.prototype.findClosestIndex = function (scale, scales) {
        if (scales === void 0) { scales = this.scaleAttr; }
        if (!scales.length)
            return;
        if (scales.length === 1)
            return 0;
        var closestIndex = scales.length - 1;
        for (var i = 0; i < scales.length; i++) {
            var current = scales[i];
            if (scale === current) {
                closestIndex = i;
                break;
            }
            if (scale < current) {
                var pre = scales[i - 1];
                closestIndex =
                    pre === undefined || Math.abs(pre - scale) <= Math.abs(current - scale) ? i - 1 : i;
                break;
            }
        }
        return closestIndex;
    };
    PreviewScales.prototype.getNextScale = function (cur, type) {
        if (type === void 0) { type = 'zoomIn'; }
        var index = this.scaleAttr.indexOf(cur);
        if (index === -1) {
            index = this.findClosestIndex(cur);
        }
        if (type === 'zoomIn') {
            return index === this.scaleAttr.length - 1 ? cur : this.scaleAttr[index + 1];
        }
        return index === 0 ? cur : this.scaleAttr[index - 1];
    };
    return PreviewScales;
}());
/* harmony default export */ var getScale = (PreviewScales);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/getFixTranslate.js
function getFixTranslate(wrapperRect, imgRect, translateX, translateY, scale) {
    var fixTranslateX = translateX;
    var fixTranslateY = translateY;
    if (translateX) {
        // No translateX if width of img is smaller than width of wrapper
        if (wrapperRect.width > imgRect.width) {
            fixTranslateX = 0;
        }
        else {
            // Width of image is greater than width of wrapper
            if (imgRect.left > wrapperRect.left) {
                // Reduce translateX to make image move to left if left side of image is within wrapper
                fixTranslateX -= Math.abs(wrapperRect.left - imgRect.left) / scale;
            }
            if (imgRect.right < wrapperRect.right) {
                // Enlarge translateX to make image move to right if right side of image is within wrapper
                fixTranslateX += Math.abs(wrapperRect.right - imgRect.right) / scale;
            }
        }
    }
    if (translateY) {
        // No translateY if height of img is smaller than height of wrapper
        if (wrapperRect.height > imgRect.height) {
            fixTranslateY = 0;
        }
        else {
            // Height of image is greater than height of wrapper
            if (imgRect.top > wrapperRect.top) {
                // Reduce translateY to make image move to top if top side of image is within wrapper
                fixTranslateY -= Math.abs(wrapperRect.top - imgRect.top) / scale;
            }
            if (imgRect.bottom < wrapperRect.bottom) {
                // Enlarge translateY to make image move to bottom if bottom side of image is within wrapper
                fixTranslateY += Math.abs(wrapperRect.bottom - imgRect.bottom) / scale;
            }
        }
    }
    return [fixTranslateX, fixTranslateY];
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMore/index.js
var IconMore = __webpack_require__(47962);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/trigger-for-toolbar.js
var trigger_for_toolbar = __webpack_require__(82411);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview-toolbar.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





var ImagePreviewToolbar = function (props, ref) {
    var _a;
    var prefixCls = props.prefixCls, previewPrefixCls = props.previewPrefixCls, _b = props.simple, simple = _b === void 0 ? false : _b, _c = props.actions, actions = _c === void 0 ? [] : _c, _d = props.actionsLayout, actionsLayout = _d === void 0 ? [] : _d, _e = props.defaultActions, defaultActions = _e === void 0 ? [] : _e;
    // Filter based on layout
    var actionsLayoutSet = new Set(actionsLayout);
    var filterWithLayout = function (item) { return actionsLayoutSet.has(item.key); };
    var filteredActions = __spreadArray(__spreadArray([], __read(defaultActions.filter(filterWithLayout)), false), __read(actions.filter(filterWithLayout)), false);
    var extraActions = actions.filter(function (item) { return !actionsLayoutSet.has(item.key); });
    // Sort by layout
    var resultActions = filteredActions.sort(function (pre, cur) {
        var preIndex = actionsLayout.indexOf(pre.key);
        var curIndex = actionsLayout.indexOf(cur.key);
        return preIndex > curIndex ? 1 : -1;
    });
    if (actionsLayoutSet.has('extra')) {
        var extraIndex = actionsLayout.indexOf('extra');
        resultActions.splice.apply(resultActions, __spreadArray([extraIndex, 0], __read(extraActions), false));
    }
    var renderAction = function (itemData, renderName) {
        var _a;
        if (renderName === void 0) { renderName = false; }
        var content = itemData.content, disabled = itemData.disabled, key = itemData.key, name = itemData.name, getContainer = itemData.getContainer, onClick = itemData.onClick, rest = __rest(itemData, ["content", "disabled", "key", "name", "getContainer", "onClick"]);
        var action = (react.createElement("div", __assign({ className: (0,_util_classNames/* default */.Z)(previewPrefixCls + "-toolbar-action", (_a = {},
                _a[previewPrefixCls + "-toolbar-action-disabled"] = disabled,
                _a)), key: key, onClick: function (e) {
                if (!disabled && onClick) {
                    onClick(e);
                }
            }, onMouseDown: function (e) {
                // To solve the problem that tooltip is selected when button is quickly clicked
                e.preventDefault();
            } }, rest),
            content && react.createElement("span", { className: previewPrefixCls + "-toolbar-action-content" }, content),
            renderName && name && (react.createElement("span", { className: previewPrefixCls + "-toolbar-action-name" }, name))));
        if (getContainer) {
            return getContainer(action);
        }
        return action;
    };
    if (!resultActions.length)
        return null;
    var actionList = resultActions.map(function (item) {
        var action = renderAction(item, simple);
        if (!simple && item.name && !item.getContainer) {
            return (react.createElement(Tooltip/* default */.Z, { content: item.name, key: item.key }, action));
        }
        return action;
    });
    return (react.createElement("div", { ref: ref, className: (0,_util_classNames/* default */.Z)(previewPrefixCls + "-toolbar", (_a = {},
            _a[previewPrefixCls + "-toolbar-simple"] = simple,
            _a), props.className), style: props.style },
        simple && (react.createElement(trigger_for_toolbar/* TriggerForToolbar */.y, { prefixCls: prefixCls, className: previewPrefixCls + "-trigger", popup: function () { return react.createElement("div", null, actionList); } }, renderAction({
            key: 'trigger',
            content: (react.createElement("span", null,
                react.createElement(IconMore/* default */.Z, null))),
        }))),
        !simple && actionList));
};
/* harmony default export */ var image_preview_toolbar = ((0,react.forwardRef)(ImagePreviewToolbar));

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Portal/index.js + 1 modules
var Portal = __webpack_require__(45497);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/previewGroupContext.js
var previewGroupContext = __webpack_require__(83417);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview-arrow.js





function ImagePreviewArrow(props) {
    var _a, _b;
    var current = props.current, previewCount = props.previewCount, _c = props.infinite, infinite = _c === void 0 ? false : _c, onPrev = props.onPrev, onNext = props.onNext;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('image-preview');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-arrow");
    var disableLeft = !infinite && current <= 0;
    var disableRight = !infinite && current >= previewCount - 1;
    return (react.createElement("div", { className: classNames },
        react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-arrow-left", (_a = {},
                _a[prefixCls + "-arrow-disabled"] = disableLeft,
                _a)), onClick: function (e) {
                e.preventDefault();
                !disableLeft && onPrev && onPrev();
            } },
            react.createElement(IconLeft/* default */.Z, null)),
        react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-arrow-right", (_b = {},
                _b[prefixCls + "-arrow-disabled"] = disableRight,
                _b)), onClick: function (e) {
                e.preventDefault();
                !disableRight && onNext && onNext();
            } },
            react.createElement(IconRight/* default */.Z, null))));
}
/* harmony default export */ var image_preview_arrow = (ImagePreviewArrow);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useOverflowHidden.js
var useOverflowHidden = __webpack_require__(88271);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useUpdate.js
var useUpdate = __webpack_require__(1083);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview.js
var image_preview_assign = (undefined && undefined.__assign) || function () {
    image_preview_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return image_preview_assign.apply(this, arguments);
};
var image_preview_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var image_preview_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




























var ROTATE_STEP = 90;
var defaultProps = {
    maskClosable: true,
    closable: true,
    breakPoint: 316,
    actionsLayout: [
        'fullScreen',
        'rotateRight',
        'rotateLeft',
        'zoomIn',
        'zoomOut',
        'originalSize',
        'extra',
    ],
    getPopupContainer: function () { return document.body; },
    escToExit: true,
    scales: defaultScales,
};
function Preview(baseProps, ref) {
    var _a, _b;
    var _c = (0,react.useContext)(previewGroupContext/* PreviewGroupContext */.v), previewGroup = _c.previewGroup, previewUrlMap = _c.previewUrlMap, currentIndex = _c.currentIndex, setCurrentIndex = _c.setCurrentIndex, infinite = _c.infinite, previewPropsMap = _c.previewPropsMap;
    var mergedPreviewProps = previewGroup ? previewPropsMap.get(currentIndex) : {};
    var mergedProps = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, mergedPreviewProps);
    var className = mergedProps.className, style = mergedProps.style, src = mergedProps.src, defaultVisible = mergedProps.defaultVisible, maskClosable = mergedProps.maskClosable, closable = mergedProps.closable, breakPoint = mergedProps.breakPoint, actions = mergedProps.actions, actionsLayout = mergedProps.actionsLayout, getPopupContainer = mergedProps.getPopupContainer, onVisibleChange = mergedProps.onVisibleChange, scales = mergedProps.scales, escToExit = mergedProps.escToExit, _d = mergedProps.imgAttributes, imgAttributes = _d === void 0 ? {} : _d, _e = mergedProps.extra, extraNode = _e === void 0 ? null : _e;
    var mergedSrc = previewGroup ? previewUrlMap.get(currentIndex) : src;
    var _f = image_preview_read((0,react.useState)(mergedSrc), 2), previewImgSrc = _f[0], setPreviewImgSrc = _f[1];
    var _g = image_preview_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: defaultVisible,
        value: mergedProps.visible,
    }), 2), visible = _g[0], setVisible = _g[1];
    var globalContext = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_);
    var getPrefixCls = globalContext.getPrefixCls, locale = globalContext.locale, rtl = globalContext.rtl;
    var prefixCls = getPrefixCls('image');
    var previewPrefixCls = prefixCls + "-preview";
    var classNames = (0,_util_classNames/* default */.Z)(previewPrefixCls, (_a = {},
        _a[previewPrefixCls + "-hide"] = !visible,
        _a[previewPrefixCls + "-rtl"] = rtl,
        _a), className);
    var refImage = (0,react.useRef)();
    var refImageContainer = (0,react.useRef)();
    var refWrapper = (0,react.useRef)();
    var keyboardEventOn = (0,react.useRef)(false);
    var refMoveData = (0,react.useRef)({
        pageX: 0,
        pageY: 0,
        originX: 0,
        originY: 0,
    });
    var _h = (0,useImageStatus/* default */.Z)('loading'), isLoading = _h.isLoading, isLoaded = _h.isLoaded, setStatus = _h.setStatus;
    var _j = image_preview_read((0,react.useState)(false), 2), toolbarSimple = _j[0], setToolbarSimple = _j[1];
    var _k = image_preview_read((0,react.useState)({ x: 0, y: 0 }), 2), translate = _k[0], setTranslate = _k[1];
    var _l = image_preview_read((0,react.useState)(1), 2), scale = _l[0], setScale = _l[1];
    var _m = image_preview_read((0,react.useState)(false), 2), scaleValueVisible = _m[0], setScaleValueVisible = _m[1];
    var _o = image_preview_read((0,react.useState)(0), 2), rotate = _o[0], setRotate = _o[1];
    var _p = image_preview_read((0,react.useState)(false), 2), moving = _p[0], setMoving = _p[1];
    var previewScales = (0,react.useMemo)(function () {
        return new getScale(scales);
    }, []);
    var onLoad = imgAttributes.onLoad, onError = imgAttributes.onError, onMouseDown = imgAttributes.onMouseDown, imgStyle = imgAttributes.style, imgClassName = imgAttributes.className, restImgAttributes = image_preview_rest(imgAttributes, ["onLoad", "onError", "onMouseDown", "style", "className"]);
    // Reset image params
    function reset() {
        setTranslate({ x: 0, y: 0 });
        setScale(1);
        setRotate(0);
    }
    (0,react.useImperativeHandle)(ref, function () { return ({
        reset: reset,
    }); });
    var _q = image_preview_read((0,react.useState)(), 2), container = _q[0], setContainer = _q[1];
    var getContainer = (0,react.useCallback)(function () { return container; }, [container]);
    (0,react.useEffect)(function () {
        var container = getPopupContainer && getPopupContainer();
        var containerDom = ((0,react_dom.findDOMNode)(container) || document.body);
        setContainer(containerDom);
    }, [getPopupContainer]);
    (0,useOverflowHidden/* default */.Z)(getContainer, { hidden: visible });
    var isFixed = (0,react.useMemo)(function () { return !dom/* isServerRendering */.ET && container === document.body; }, [container]);
    // Jump to image at the specified index
    function jumpTo(index) {
        var previewListLen = previewUrlMap.size;
        if (infinite) {
            index %= previewListLen;
            if (index < 0)
                index = previewListLen - Math.abs(index);
        }
        if (index !== currentIndex && index >= 0 && index <= previewListLen - 1) {
            setCurrentIndex(index);
        }
    }
    function onPrev() {
        jumpTo(currentIndex - 1);
    }
    function onNext() {
        jumpTo(currentIndex + 1);
    }
    // Anticlockwise rotation
    function onRotateLeft() {
        setRotate(rotate === 0 ? 360 - ROTATE_STEP : rotate - ROTATE_STEP);
    }
    // Clockwise rotation
    function onRotateRight() {
        setRotate((rotate + ROTATE_STEP) % 360);
    }
    // Scale
    var hideScaleTimer = (0,react.useRef)(null);
    var showScaleValue = function () {
        !scaleValueVisible && setScaleValueVisible(true);
        hideScaleTimer.current && clearTimeout(hideScaleTimer.current);
        hideScaleTimer.current = setTimeout(function () {
            setScaleValueVisible(false);
        }, 1000);
    };
    var onScaleChange = function (newScale) {
        if (scale !== newScale) {
            setScale(newScale);
            showScaleValue();
        }
    };
    function onZoomIn() {
        var newScale = previewScales.getNextScale(scale, 'zoomIn');
        onScaleChange(newScale);
    }
    function onZoomOut() {
        var newScale = previewScales.getNextScale(scale, 'zoomOut');
        onScaleChange(newScale);
    }
    function onWheelZoom(e) {
        if (e.deltaY > 0) {
            // 缩小
            if (scale >= previewScales.minScale) {
                // e.preventDefault();
                onZoomOut();
            }
        }
        else if (scale <= previewScales.maxScale) {
            // e.preventDefault();
            onZoomIn();
        }
    }
    function onResetScale() {
        onScaleChange(1);
    }
    function onFullScreen() {
        var wrapperRect = refWrapper.current.getBoundingClientRect();
        var imgRect = refImage.current.getBoundingClientRect();
        var newHeightScale = wrapperRect.height / (imgRect.height / scale);
        var newWidthScale = wrapperRect.width / (imgRect.width / scale);
        var newScale = Math.max(newHeightScale, newWidthScale);
        onScaleChange(newScale);
    }
    // Image container is clicked
    function onOutsideImgClick(e) {
        if (e.target === e.currentTarget && maskClosable) {
            close();
        }
    }
    // Close button is clicked.
    function onCloseClick() {
        close();
    }
    function close() {
        if (visible) {
            onVisibleChange && onVisibleChange(false, visible);
            (0,is/* isUndefined */.o8)(mergedProps.visible) && setVisible(false);
        }
    }
    function onWrapperResize(entry) {
        if (entry && entry.length) {
            var wrapperRect = entry[0].contentRect;
            var nextSimple = wrapperRect.width < breakPoint;
            setToolbarSimple(nextSimple);
        }
    }
    // Check the translate and correct it if needed
    var checkAndFixTranslate = function () {
        if (!refWrapper.current || !refImage.current)
            return;
        var wrapperRect = refWrapper.current.getBoundingClientRect();
        var imgRect = refImage.current.getBoundingClientRect();
        var _a = image_preview_read(getFixTranslate(wrapperRect, imgRect, translate.x, translate.y, scale), 2), x = _a[0], y = _a[1];
        if (x !== translate.x || y !== translate.y) {
            setTranslate({
                x: x,
                y: y,
            });
        }
    };
    // Update position on moving if needed
    var onMoving = function (e) {
        if (visible && moving) {
            e.preventDefault && e.preventDefault();
            var _a = refMoveData.current, originX = _a.originX, originY = _a.originY, pageX = _a.pageX, pageY = _a.pageY;
            var nextX = originX + (e.pageX - pageX) / scale;
            var nextY = originY + (e.pageY - pageY) / scale;
            setTranslate({
                x: nextX,
                y: nextY,
            });
        }
    };
    var onMoveEnd = function (e) {
        e.preventDefault && e.preventDefault();
        setMoving(false);
    };
    function onImgLoaded(e) {
        setStatus('loaded');
        onLoad && onLoad(e);
    }
    function onImgLoadError(e) {
        setStatus('error');
        onError && onError(e);
    }
    // Record position data on move start
    var onMoveStart = function (e) {
        var _a;
        (_a = e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
        setMoving(true);
        var ev = e.type === 'touchstart' ? e.touches[0] : e;
        refMoveData.current.pageX = ev.pageX;
        refMoveData.current.pageY = ev.pageY;
        refMoveData.current.originX = translate.x;
        refMoveData.current.originY = translate.y;
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
    };
    (0,react.useEffect)(function () {
        if (visible && moving) {
            (0,dom.on)(document, 'mousemove', onMoving, false);
            (0,dom.on)(document, 'mouseup', onMoveEnd, false);
        }
        return function () {
            (0,dom/* off */.S1)(document, 'mousemove', onMoving, false);
            (0,dom/* off */.S1)(document, 'mouseup', onMoveEnd, false);
        };
    }, [visible, moving]);
    // Correct translate after moved
    (0,react.useEffect)(function () {
        if (!moving) {
            checkAndFixTranslate();
        }
    }, [moving, translate]);
    // Correct translate when scale changes
    (0,react.useEffect)(function () {
        checkAndFixTranslate();
    }, [scale]);
    // Reset when preview is opened
    (0,react.useEffect)(function () {
        if (visible) {
            reset();
        }
    }, [visible]);
    // Reset on first mount or image switches
    (0,react.useEffect)(function () {
        setPreviewImgSrc(mergedSrc);
        setStatus(mergedSrc ? 'loading' : 'loaded');
        reset();
    }, [mergedSrc]);
    (0,useUpdate/* default */.Z)(function () {
        previewScales.updateScale(scales);
        setScale(1);
    }, [scales]);
    // Close when pressing esc
    (0,react.useEffect)(function () {
        var onKeyDown = function (e) {
            if (e) {
                switch (e.key) {
                    case keycode/* Esc.key */.AV.key:
                        if (escToExit) {
                            close();
                        }
                        break;
                    case keycode/* ArrowRight.key */.ol.key:
                        onNext();
                        break;
                    case keycode/* ArrowLeft.key */.Xd.key:
                        onPrev();
                        break;
                    case keycode/* ArrowUp.key */.a2.key:
                        onZoomIn();
                        break;
                    case keycode/* ArrowDown.key */.K5.key:
                        onZoomOut();
                        break;
                    default:
                }
            }
        };
        if (visible && !moving && !keyboardEventOn.current) {
            keyboardEventOn.current = true;
            (0,dom.on)(document, 'keydown', onKeyDown);
        }
        return function () {
            keyboardEventOn.current = false;
            (0,dom/* off */.S1)(document, 'keydown', onKeyDown);
        };
    }, [visible, escToExit, moving, currentIndex, scale]);
    var defaultActions = [
        {
            key: 'fullScreen',
            name: locale.ImagePreview.fullScreen,
            content: react.createElement(IconFullscreen/* default */.Z, null),
            onClick: onFullScreen,
        },
        {
            key: 'rotateRight',
            name: locale.ImagePreview.rotateRight,
            content: react.createElement(IconRotateRight/* default */.Z, null),
            onClick: onRotateRight,
        },
        {
            key: 'rotateLeft',
            name: locale.ImagePreview.rotateLeft,
            content: react.createElement(IconRotateLeft/* default */.Z, null),
            onClick: onRotateLeft,
        },
        {
            key: 'zoomIn',
            name: locale.ImagePreview.zoomIn,
            content: react.createElement(IconZoomIn/* default */.Z, null),
            onClick: onZoomIn,
            disabled: scale === previewScales.maxScale,
        },
        {
            key: 'zoomOut',
            name: locale.ImagePreview.zoomOut,
            content: react.createElement(IconZoomOut/* default */.Z, null),
            onClick: onZoomOut,
            disabled: scale === previewScales.minScale,
        },
        {
            key: 'originalSize',
            name: locale.ImagePreview.originalSize,
            content: react.createElement(IconOriginalSize/* default */.Z, null),
            onClick: onResetScale,
        },
    ];
    return (react.createElement(Portal/* default */.Z, { visible: visible, forceRender: false, getContainer: getContainer },
        react.createElement(ConfigProvider/* default */.ZP, image_preview_assign({}, globalContext, { getPopupContainer: function () { return refWrapper.current; } }),
            react.createElement("div", { className: classNames, style: image_preview_assign(image_preview_assign({}, (style || {})), (isFixed ? {} : { zIndex: 'inherit', position: 'absolute' })) },
                react.createElement(CSSTransition/* default */.Z, { in: visible, timeout: 400, appear: true, classNames: "fadeImage", mountOnEnter: true, unmountOnExit: false, onEnter: function (e) {
                        e.parentNode.style.display = 'block';
                        e.style.display = 'block';
                    }, onExited: function (e) {
                        e.parentNode.style.display = '';
                        e.style.display = 'none';
                    } },
                    react.createElement("div", { className: previewPrefixCls + "-mask" })),
                visible && (react.createElement(resizeObserver/* default */.Z, { onResize: onWrapperResize },
                    react.createElement("div", { ref: refWrapper, className: previewPrefixCls + "-wrapper", onClick: onOutsideImgClick },
                        react.createElement("div", { ref: refImageContainer, className: previewPrefixCls + "-img-container", style: { transform: "scale(" + scale + ", " + scale + ")" }, onClick: onOutsideImgClick },
                            react.createElement("img", image_preview_assign({ onWheel: onWheelZoom, ref: refImage, className: (0,_util_classNames/* default */.Z)(imgClassName, previewPrefixCls + "-img", (_b = {},
                                    _b[previewPrefixCls + "-img-moving"] = moving,
                                    _b)), style: image_preview_assign(image_preview_assign({}, imgStyle), { transform: "translate(" + translate.x + "px, " + translate.y + "px) rotate(" + rotate + "deg)" }) }, restImgAttributes, { onLoad: onImgLoaded, onError: onImgLoadError, onMouseDown: function (event) {
                                    // only trigger onMoveStart when press mouse left button
                                    event.button === 0 && onMoveStart(event);
                                }, key: previewImgSrc, src: previewImgSrc })),
                            isLoading && (react.createElement("div", { className: previewPrefixCls + "-loading" },
                                react.createElement(IconLoading/* default */.Z, null)))),
                        react.createElement(CSSTransition/* default */.Z, { in: scaleValueVisible, timeout: 400, appear: true, classNames: "fadeImage", unmountOnExit: true },
                            react.createElement("div", { className: previewPrefixCls + "-scale-value" },
                                (scale * 100).toFixed(0),
                                "%")),
                        isLoaded && (react.createElement(image_preview_toolbar, { prefixCls: prefixCls, previewPrefixCls: previewPrefixCls, actions: actions, actionsLayout: actionsLayout, defaultActions: defaultActions, simple: toolbarSimple })),
                        closable && (react.createElement("div", { className: previewPrefixCls + "-close-btn", onClick: onCloseClick },
                            react.createElement(IconClose/* default */.Z, null))),
                        previewGroup && (react.createElement(image_preview_arrow, { previewCount: previewUrlMap.size, current: currentIndex, infinite: infinite, onPrev: onPrev, onNext: onNext })),
                        extraNode)))))));
}
var PreviewComponent = (0,react.forwardRef)(Preview);
PreviewComponent.displayName = 'ImagePreview';
/* harmony default export */ var image_preview = (PreviewComponent);


/***/ }),

/***/ 83417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ PreviewGroupContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var PreviewGroupContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    previewGroup: false,
    previewUrlMap: new Map(),
    previewPropsMap: new Map(),
    infinite: true,
    currentIndex: 0,
    setCurrentIndex: function () { return null; },
    setPreviewUrlMap: function () { return null; },
    registerPreviewUrl: function () { return null; },
    registerPreviewProps: function () { return null; },
    visible: false,
    handleVisibleChange: function () { return null; },
});


/***/ }),

/***/ 82411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ TriggerForToolbar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Trigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12830);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34855);



var TriggerForToolbar = function (props) {
    var style = props.style, className = props.className, prefixCls = props.prefixCls, popup = props.popup, children = props.children;
    var classNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prefixCls + "-trigger", className);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Trigger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { style: style, className: classNames, popup: popup, showArrow: true }, children));
};


/***/ }),

/***/ 83062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function useImageStatus(defaultValue) {
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue), 2), status = _a[0], setStatus = _a[1];
    var isBeforeLoad = status === 'beforeLoad';
    var isLoading = status === 'loading';
    var isError = status === 'error';
    var isLoaded = status === 'loaded';
    var isLazyLoad = status === 'lazyload';
    return {
        status: status,
        isBeforeLoad: isBeforeLoad,
        isLoading: isLoading,
        isError: isError,
        isLoaded: isLoaded,
        isLazyLoad: isLazyLoad,
        setStatus: setStatus,
    };
}


/***/ }),

/***/ 1393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconSearch/index.js
var IconSearch = __webpack_require__(22208);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/search.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var Search = react.forwardRef(function (props, ref) {
    var _a;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var className = props.className, style = props.style, placeholder = props.placeholder, disabled = props.disabled, searchButton = props.searchButton, loading = props.loading, defaultValue = props.defaultValue, rest = __rest(props, ["className", "style", "placeholder", "disabled", "searchButton", "loading", "defaultValue"]);
    var trueMaxLength = (0,is/* isObject */.Kn)(props.maxLength) ? props.maxLength.length : props.maxLength;
    var mergedMaxLength = (0,is/* isObject */.Kn)(props.maxLength) && props.maxLength.errorOnly ? undefined : trueMaxLength;
    var _b = __read((0,useMergeValue/* default */.Z)('', {
        defaultValue: 'defaultValue' in props ? formatValue(props.defaultValue, mergedMaxLength) : undefined,
        value: 'value' in props ? formatValue(props.value, mergedMaxLength) : undefined,
    }), 2), value = _b[0], setValue = _b[1];
    var prefixCls = getPrefixCls('input-search');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-button"] = searchButton,
        _a), className);
    var onSearch = function () {
        !disabled && props.onSearch && props.onSearch(value);
    };
    return (react.createElement(input, __assign({}, (0,omit/* default */.Z)(rest, ['onSearch']), { disabled: disabled, className: classNames, style: style, ref: ref, placeholder: placeholder, addAfter: searchButton ? (react.createElement(Button/* default */.Z, { disabled: disabled, size: rest.size, className: prefixCls + "-btn", type: "primary", onClick: onSearch, loading: loading, loadingFixedWidth: true, icon: searchButton === true && !loading && react.createElement(IconSearch/* default */.Z, null) }, searchButton !== true && searchButton)) : null, suffix: !searchButton && (loading ? react.createElement(IconLoading/* default */.Z, null) : react.createElement(IconSearch/* default */.Z, { onClick: onSearch })), onChange: function (value, e) {
            setValue(value);
            props.onChange && props.onChange(value, e);
        }, defaultValue: defaultValue, onPressEnter: function (e) {
            onSearch();
            props.onPressEnter && props.onPressEnter(e);
        } })));
});
Search.displayName = 'Search';
/* harmony default export */ var search = (Search);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/autoSizeTextAreaHeight.js
// auto set textarea height

var mirrorTextAreaStyle = "\n  position: absolute;\n  min-height: 0 !important;\n  max-height: none;\n  height:0;\n  visibility: hidden;\n  z-index: -100;\n  top: 0;\n  right: 0;\n";
var mirrorTextAreaSizing = [
    'border-width',
    'box-sizing',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'text-indent',
    'text-rendering',
    'text-transform',
    'width',
];
var mirrorTextArea;
function setMirrorTextArea(originTextArea) {
    if (!mirrorTextArea) {
        mirrorTextArea = document.createElement('textarea');
        document.body.appendChild(mirrorTextArea);
    }
    var originStyle = window.getComputedStyle(originTextArea);
    var originSizingStyle = "\n    " + mirrorTextAreaSizing.map(function (attr) { return attr + ":" + originStyle.getPropertyValue(attr); }).join(';') + "\n  ";
    mirrorTextArea.setAttribute('style', "" + mirrorTextAreaStyle + originSizingStyle);
    var paddingSize = parseFloat(originStyle.getPropertyValue('padding-top')) +
        parseFloat(originStyle.getPropertyValue('padding-bottom'));
    var boxSizing = originStyle.getPropertyValue('box-sizing');
    var borderSize = parseFloat(originStyle.getPropertyValue('border-top-width')) +
        parseFloat(originStyle.getPropertyValue('border-bottom-width'));
    return {
        paddingSize: paddingSize,
        boxSizing: boxSizing,
        borderSize: borderSize,
    };
}
function autoSizeTextAreaHeight(autoSize, node) {
    var getRows = function () {
        var minRows;
        var maxRows;
        if ((0,is/* isObject */.Kn)(autoSize)) {
            minRows = autoSize.minRows;
            maxRows = autoSize.maxRows;
        }
        return {
            minRows: minRows,
            maxRows: maxRows,
        };
    };
    if (autoSize) {
        var _a = getRows(), minRows = _a.minRows, maxRows = _a.maxRows;
        var originTextNode = node;
        var _b = setMirrorTextArea(originTextNode), paddingSize = _b.paddingSize, boxSizing = _b.boxSizing, borderSize = _b.borderSize;
        mirrorTextArea.value = originTextNode.value || originTextNode.placeholder || '';
        var mirrorTextAreaHeight = mirrorTextArea.scrollHeight + borderSize;
        var minHeight = void 0;
        var maxHeight = void 0;
        var overflowY = void 0;
        if (minRows || maxRows) {
            mirrorTextArea.value = '';
            var singleRowHeight = mirrorTextArea.scrollHeight - paddingSize;
            if ((0,is/* isNumber */.hj)(minRows)) {
                minHeight = singleRowHeight * minRows;
                if (boxSizing === 'border-box') {
                    minHeight += paddingSize;
                    minHeight += borderSize;
                }
                mirrorTextAreaHeight = Math.max(mirrorTextAreaHeight, minHeight);
            }
            if ((0,is/* isNumber */.hj)(maxRows)) {
                maxHeight = singleRowHeight * maxRows;
                if (boxSizing === 'border-box') {
                    maxHeight += paddingSize;
                    maxHeight += borderSize;
                }
                overflowY = mirrorTextAreaHeight > maxHeight ? 'auto' : '';
                maxHeight = Math.min(mirrorTextAreaHeight, maxHeight);
            }
        }
        var textAreaStyle = {};
        textAreaStyle.height = mirrorTextAreaHeight;
        if (minHeight) {
            textAreaStyle.minHeight = minHeight;
        }
        if (maxHeight) {
            textAreaStyle.maxHeight = maxHeight;
        }
        if (overflowY) {
            textAreaStyle.overflowY = overflowY;
        }
        return textAreaStyle;
    }
}
/* harmony default export */ var Input_autoSizeTextAreaHeight = (autoSizeTextAreaHeight);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(81109);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/useComposition.js
var useComposition = __webpack_require__(36211);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/textarea.js
var textarea_assign = (undefined && undefined.__assign) || function () {
    textarea_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return textarea_assign.apply(this, arguments);
};
var textarea_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var textarea_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var TextArea = function (props, ref) {
    var _a, _b, _c;
    var className = props.className, style = props.style, wrapperStyle = props.wrapperStyle, placeholder = props.placeholder, disabled = props.disabled, error = props.error, propMaxLength = props.maxLength, showWordLimit = props.showWordLimit, allowClear = props.allowClear, onChange = props.onChange, onClear = props.onClear, onKeyDown = props.onKeyDown, onPressEnter = props.onPressEnter, status = props.status, clearIcon = props.clearIcon, rest = textarea_rest(props, ["className", "style", "wrapperStyle", "placeholder", "disabled", "error", "maxLength", "showWordLimit", "allowClear", "onChange", "onClear", "onKeyDown", "onPressEnter", "status", "clearIcon"]);
    // Only for error judgement
    var wordLimitMaxLength = (0,is/* isObject */.Kn)(propMaxLength) ? propMaxLength.length : propMaxLength;
    // The real maxLength passed to input element
    var maxLength = (0,is/* isObject */.Kn)(propMaxLength)
        ? propMaxLength.errorOnly
            ? undefined
            : propMaxLength.length
        : propMaxLength;
    var textareaRef = (0,react.useRef)();
    var _d = textarea_read((0,react.useState)({}), 2), textAreaStyle = _d[0], setTextAreaStyle = _d[1];
    var _e = textarea_read((0,useMergeValue/* default */.Z)('', {
        defaultValue: 'defaultValue' in props ? formatValue(props.defaultValue, maxLength) : undefined,
        value: 'value' in props ? formatValue(props.value, maxLength) : undefined,
    }), 2), value = _e[0], setValue = _e[1];
    var _f = (0,useComposition/* default */.Z)({
        value: value,
        maxLength: maxLength,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onPressEnter: onPressEnter,
        beforeTriggerValueChangeCallback: function (v) {
            if (!('value' in props) && (maxLength === undefined || v.length <= maxLength)) {
                setValue(v);
            }
        },
    }), compositionValue = _f.compositionValue, compositionHandler = _f.compositionHandler, valueChangeHandler = _f.valueChangeHandler, keyDownHandler = _f.keyDownHandler, triggerValueChangeCallback = _f.triggerValueChangeCallback;
    var textareaDisplayedText = compositionValue || value || '';
    var _g = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _g.getPrefixCls, rtl = _g.rtl;
    var prefixCls = getPrefixCls('textarea');
    if (disabled) {
        textAreaStyle.resize = 'none';
    }
    // set element focus and caret position
    var onFocus = function () {
        if (textareaRef.current && textareaRef.current.focus) {
            if (textareaRef.current.setSelectionRange) {
                var caretPos = textareaRef.current.textContent.length;
                // reference: https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                textareaRef.current.setSelectionRange(caretPos, caretPos);
            }
            textareaRef.current.focus();
        }
    };
    var resizeTextAreaHeight = function () {
        var textAreaStyle = Input_autoSizeTextAreaHeight(props.autoSize, textareaRef.current);
        if (textAreaStyle) {
            setTextAreaStyle(textAreaStyle);
        }
    };
    var handleClearClick = function (e) {
        e.stopPropagation();
        onFocus();
        triggerValueChangeCallback('', e);
        onClear && onClear();
    };
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        resizeTextAreaHeight();
    }, [textareaDisplayedText]);
    (0,react.useImperativeHandle)(ref, function () { return ({
        dom: textareaRef.current,
        focus: function () {
            onFocus();
        },
        blur: function () {
            textareaRef.current && textareaRef.current.blur && textareaRef.current.blur();
        },
    }); }, []);
    var valueLength = value ? value.length : 0;
    var withWrapper = (wordLimitMaxLength && showWordLimit) || allowClear;
    var lengthError = (0,react.useMemo)(function () {
        if (!maxLength && wordLimitMaxLength) {
            return valueLength > wordLimitMaxLength;
        }
        return false;
    }, [valueLength, wordLimitMaxLength, maxLength]);
    var inputStatus = status || (error || lengthError ? 'error' : undefined);
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-" + inputStatus] = inputStatus,
        // [`${prefixCls}-error`]: error || lengthError || status === 'error',
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var TextAreaElement = (react.createElement("textarea", textarea_assign({}, (0,omit/* default */.Z)(rest, ['autoSize', 'defaultValue']), { maxLength: maxLength, ref: textareaRef, style: textarea_assign(textarea_assign({}, style), textAreaStyle), className: classNames, placeholder: placeholder, disabled: disabled, value: textareaDisplayedText, onChange: valueChangeHandler, onKeyDown: keyDownHandler, onCompositionStart: compositionHandler, onCompositionUpdate: compositionHandler, onCompositionEnd: compositionHandler })));
    if (withWrapper) {
        var showClearIcon = !disabled && allowClear && value;
        var _h = textarea_read(rtl
            ? [wordLimitMaxLength, valueLength]
            : [valueLength, wordLimitMaxLength], 2), leftWord = _h[0], rightWord = _h[1];
        return (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-wrapper", (_b = {},
                _b[prefixCls + "-clear-wrapper"] = allowClear,
                _b[prefixCls + "-wrapper-rtl"] = rtl,
                _b)), style: wrapperStyle },
            TextAreaElement,
            showClearIcon ? (clearIcon !== undefined ? (react.createElement("span", { className: prefixCls + "-clear-icon", onClick: handleClearClick, onMouseDown: function (e) {
                    e.preventDefault();
                } }, clearIcon)) : (react.createElement(icon_hover/* default */.Z, { className: prefixCls + "-clear-icon" },
                react.createElement(IconClose/* default */.Z, { onClick: handleClearClick, 
                    // keep focus status
                    onMouseDown: function (e) {
                        e.preventDefault();
                    } })))) : null,
            wordLimitMaxLength && showWordLimit && (react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-word-limit", (_c = {},
                    _c[prefixCls + "-word-limit-error"] = lengthError,
                    _c)) },
                leftWord,
                "/",
                rightWord))));
    }
    return TextAreaElement;
};
var TextAreaRef = react.forwardRef(TextArea);
TextAreaRef.displayName = 'TextArea';
/* harmony default export */ var Input_textarea = (TextAreaRef);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEye/index.js
var IconEye = __webpack_require__(23835);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEyeInvisible/index.js
var IconEyeInvisible = __webpack_require__(95280);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/password.js
var password_assign = (undefined && undefined.__assign) || function () {
    password_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return password_assign.apply(this, arguments);
};
var password_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var password_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var Password = react.forwardRef(function (props, ref) {
    var _a;
    var _b = password_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: props.defaultVisibility,
        value: props.visibility,
    }), 2), visibility = _b[0], setVisibility = _b[1];
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var className = props.className, _c = props.visibilityToggle, visibilityToggle = _c === void 0 ? true : _c, onVisibilityChange = props.onVisibilityChange, rest = password_rest(props, ["className", "visibilityToggle", "onVisibilityChange"]);
    var prefixCls = getPrefixCls('input-password');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-visibility"] = visibilityToggle,
        _a), className);
    var onClickVisibility = function (v) {
        if (!('visibility' in props)) {
            setVisibility(v);
        }
        onVisibilityChange && onVisibilityChange(v);
    };
    var icon = props.suffix;
    var handleClickVisibility = function () {
        onClickVisibility(!visibility);
    };
    if (visibilityToggle) {
        var IconProps = password_assign({ onClick: handleClickVisibility, 
            // 预防focus丢失
            onMouseDown: function (e) { return e.preventDefault(); }, onMouseUp: function (e) { return e.preventDefault(); } }, getKeyboardEvents({
            onPressEnter: handleClickVisibility,
        }));
        if (props.suffix) {
            icon = react.createElement("span", password_assign({}, IconProps), props.suffix);
        }
        else {
            var IconComponent = visibility ? IconEye/* default */.Z : IconEyeInvisible/* default */.Z;
            icon = (react.createElement(IconComponent, password_assign({}, IconProps, {
                focusable: undefined,
                'aria-hidden': undefined,
                tabIndex: 0,
                className: prefixCls + "-visibility-icon",
            })));
        }
    }
    return (react.createElement(input, password_assign({}, (0,omit/* default */.Z)(rest, ['visibility', 'defaultVisibility']), { type: visibility ? 'text' : 'password', className: classNames, ref: ref, suffix: icon })));
});
Password.displayName = 'Password';
/* harmony default export */ var Input_password = (Password);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/input-element.js
var input_element = __webpack_require__(17538);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/group.js
var group_assign = (undefined && undefined.__assign) || function () {
    group_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return group_assign.apply(this, arguments);
};
var group_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var Group = react.forwardRef(function (props, ref) {
    var _a;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var className = props.className, style = props.style, children = props.children, compact = props.compact, rest = group_rest(props, ["className", "style", "children", "compact"]);
    var prefixCls = getPrefixCls('input-group');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-compact"] = compact,
        _a), className);
    return (react.createElement("div", group_assign({ ref: ref, className: classNames, style: style }, rest), children));
});
Group.displayName = 'InputGroup';
/* harmony default export */ var group = (Group);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/input.js
var input_assign = (undefined && undefined.__assign) || function () {
    input_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return input_assign.apply(this, arguments);
};
var input_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var keepFocus = function (e) {
    e.target.tagName !== 'INPUT' && e.preventDefault();
};
var inputAddon = function (className, node, style, onClick) {
    if (style === void 0) { style = {}; }
    return node ? (react.createElement("span", { style: style, className: className, onClick: onClick }, node)) : null;
};
function formatValue(value, maxLength) {
    var str = value !== null && !(0,is/* isUndefined */.o8)(value) && !(0,is/* isString */.HD)(value) ? String(value) : value || '';
    if (maxLength) {
        return str.slice(0, maxLength);
    }
    return str;
}
function Input(baseProps, ref) {
    var _a, _b, _c;
    var _d = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _d.getPrefixCls, ctxSize = _d.size, componentConfig = _d.componentConfig, rtl = _d.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, {}, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Input);
    var className = props.className, propsStyle = props.style, addBefore = props.addBefore, addAfter = props.addAfter, suffix = props.suffix, prefix = props.prefix, beforeStyle = props.beforeStyle, afterStyle = props.afterStyle, height = props.height, disabled = props.disabled, maxLength = props.maxLength, showWordLimit = props.showWordLimit, allowClear = props.allowClear, propsAutoWidth = props.autoWidth;
    var autoWidth = propsAutoWidth
        ? input_assign({ minWidth: 0, maxWidth: '100%' }, ((0,is/* isObject */.Kn)(propsAutoWidth) ? propsAutoWidth : {})) : null;
    var style = input_assign({ minWidth: autoWidth === null || autoWidth === void 0 ? void 0 : autoWidth.minWidth, maxWidth: autoWidth === null || autoWidth === void 0 ? void 0 : autoWidth.maxWidth, width: autoWidth && 'auto' }, propsStyle);
    var trueMaxLength = (0,is/* isObject */.Kn)(maxLength) ? maxLength.length : maxLength;
    var mergedMaxLength = (0,is/* isObject */.Kn)(maxLength) && maxLength.errorOnly ? undefined : trueMaxLength;
    var _e = input_read((0,react.useState)(false), 2), focus = _e[0], setFocus = _e[1];
    var inputRef = (0,react.useRef)();
    var inputWrapperRef = (0,react.useRef)();
    var _f = input_read((0,useMergeValue/* default */.Z)('', {
        defaultValue: 'defaultValue' in props ? formatValue(props.defaultValue, mergedMaxLength) : undefined,
        value: 'value' in props ? formatValue(props.value, mergedMaxLength) : undefined,
    }), 2), value = _f[0], setValue = _f[1];
    (0,react.useImperativeHandle)(ref, function () { return inputRef.current; }, []);
    var onChange = function (value, e) {
        if (!('value' in props)) {
            setValue(value);
        }
        props.onChange && props.onChange(value, e);
    };
    var prefixCls = getPrefixCls('input');
    var size = props.size || ctxSize;
    var isCustomHeight = 'height' in props;
    var suffixElement = suffix;
    var valueLength = value ? value.length : 0;
    var lengthError = (0,react.useMemo)(function () {
        if (!mergedMaxLength && trueMaxLength) {
            return valueLength > trueMaxLength;
        }
        return false;
    }, [valueLength, trueMaxLength, mergedMaxLength]);
    if (trueMaxLength && showWordLimit) {
        var _g = input_read(rtl ? [trueMaxLength, valueLength] : [valueLength, trueMaxLength], 2), leftWord = _g[0], rightWord = _g[1];
        suffixElement = (react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-word-limit", (_a = {},
                _a[prefixCls + "-word-limit-error"] = lengthError,
                _a)) },
            leftWord,
            "/",
            rightWord));
    }
    var classnames = (0,_util_classNames/* default */.Z)(prefixCls + "-group-wrapper", prefixCls + "-group-wrapper-" + size, (_b = {},
        _b[prefixCls + "-custom-height"] = isCustomHeight,
        _b[prefixCls + "-has-suffix"] = suffixElement,
        _b[prefixCls + "-group-wrapper-disabled"] = disabled,
        _b[prefixCls + "-group-wrapper-rtl"] = rtl,
        _b[prefixCls + "-group-wrapper-autowidth"] = autoWidth,
        _b), className);
    var status = props.status || (props.error || lengthError ? 'error' : undefined);
    var needWrapper = addBefore || addAfter || suffixElement || prefix;
    var inputElement = (react.createElement(input_element/* default */.Z, input_assign({ ref: inputRef }, props, { autoFitWidth: !!autoWidth, style: style, status: status, onFocus: function (e) {
            setFocus(true);
            props.onFocus && props.onFocus(e);
        }, onBlur: function (e) {
            setFocus(false);
            props.onBlur && props.onBlur(e);
        }, onChange: onChange, prefixCls: prefixCls, value: value, hasParent: !!needWrapper || allowClear, size: size })));
    var innerWrapperClassnames = (0,_util_classNames/* default */.Z)(prefixCls + "-inner-wrapper", (_c = {},
        _c[prefixCls + "-inner-wrapper-" + status] = status,
        _c[prefixCls + "-inner-wrapper-disabled"] = disabled,
        _c[prefixCls + "-inner-wrapper-focus"] = focus,
        _c[prefixCls + "-inner-wrapper-has-prefix"] = prefix,
        _c[prefixCls + "-inner-wrapper-" + size] = size,
        _c[prefixCls + "-clear-wrapper"] = allowClear,
        _c[prefixCls + "-inner-wrapper-rtl"] = rtl,
        _c));
    return needWrapper ? (react.createElement("div", { className: classnames, style: input_assign(input_assign({}, style), (isCustomHeight ? { height: height } : {})) },
        react.createElement("span", { className: prefixCls + "-group" },
            inputAddon(prefixCls + "-group-addbefore", addBefore, beforeStyle),
            react.createElement("span", { className: innerWrapperClassnames, ref: inputWrapperRef, onMouseDown: function (e) {
                    // 直接的点击input的时候，不阻止默认行为，避免无法选中输入框里的输入文本
                    if (e.target.tagName !== 'INPUT') {
                        // 当使用React.Portal挂载的组件（tooltip, popover等）放在prefix，suffix里是，弹层中的内容无法被选中。
                        // contains 判断如果不包含在当前dom节点，则不阻止默认行为。
                        if (inputWrapperRef.current && (0,dom/* contains */.r3)(inputWrapperRef.current, e.target)) {
                            e.preventDefault();
                        }
                    }
                }, onClick: function (e) {
                    // 当使用React.Portal挂载的组件（tooltip, popover等）放在prefix，suffix里时，弹出层被点击时，不应该focus input。
                    if (inputWrapperRef.current && (0,dom/* contains */.r3)(inputWrapperRef.current, e.target)) {
                        inputRef.current && inputRef.current.focus();
                    }
                } },
                inputAddon(prefixCls + "-group-prefix", prefix),
                inputElement,
                inputAddon(prefixCls + "-group-suffix", suffixElement)),
            inputAddon(prefixCls + "-group-addafter", addAfter, afterStyle)))) : allowClear ? (react.createElement("span", { className: (0,_util_classNames/* default */.Z)(className, innerWrapperClassnames), style: input_assign(input_assign({}, style), (isCustomHeight ? { height: height } : {})), onMouseDown: keepFocus, onClick: function () {
            inputRef.current && inputRef.current.focus();
        } }, inputElement)) : (inputElement);
}
var InputElement = react.forwardRef(Input);
InputElement.displayName = 'Input';
InputElement.Search = search;
InputElement.TextArea = Input_textarea;
InputElement.Password = Input_password;
InputElement.Group = group;
/* harmony default export */ var input = (InputElement);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js

/* harmony default export */ var es_Input = (input);


/***/ }),

/***/ 17538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34855);
/* harmony import */ var _util_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50049);
/* harmony import */ var _util_resizeObserver__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68761);
/* harmony import */ var _icon_react_icon_IconClose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59547);
/* harmony import */ var _class_icon_hover__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25227);
/* harmony import */ var _util_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53367);
/* harmony import */ var _useComposition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36211);
/* harmony import */ var _util_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57483);
/* harmony import */ var _util_fillNBSP__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97931);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










// 设置 input 元素缓冲宽度，避免 autoWidth.minWidth < padding + border 时，content 区域宽度为0，光标会看不到
// 后续可考虑是否作为 autoWidth 的一个配置项暴露
var inputContentWidth = 2;
// 从 input 标签获取影响到宽度计算的"文本样式属性"和“布局”属性 https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_text
// 为什么不是直接把 input 标签的类名设置给 mirror 元素？避免用户对 input 类名自定义样式会影响到 mirror
// 仅在 mounted 的时候执行一次
var getStyleFromInput = function (input) {
    if (!input) {
        return {};
    }
    var computeStyle = window.getComputedStyle(input);
    var cssKeys = [
        'font',
        'letterSpacing',
        'overflow',
        'tabSize',
        'textIndent',
        'textTransform',
        'whiteSpace',
        'wordBreak',
        'wordSpacing',
        'paddingLeft',
        'paddingRight',
        'borderLeft',
        'borderRight',
        'boxSizing',
    ];
    return cssKeys.reduce(function (t, n) {
        t[n] = computeStyle[n];
        return t;
    }, {});
};
var InputComponent = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
    var _a;
    var allowClear = props.allowClear, disabled = props.disabled, placeholder = props.placeholder, className = props.className, style = props.style, height = props.height, prefixCls = props.prefixCls, hasParent = props.hasParent, size = props.size, value = props.value, autoFitWidth = props.autoFitWidth, onClear = props.onClear, readOnly = props.readOnly, onChange = props.onChange, onKeyDown = props.onKeyDown, onPressEnter = props.onPressEnter, propMaxLength = props.maxLength, clearIcon = props.clearIcon, rest = __rest(props, ["allowClear", "disabled", "placeholder", "className", "style", "height", "prefixCls", "hasParent", "size", "value", "autoFitWidth", "onClear", "readOnly", "onChange", "onKeyDown", "onPressEnter", "maxLength", "clearIcon"]);
    var otherProps = (0,_util_omit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(rest, [
        'error',
        'status',
        'showWordLimit',
        'className',
        'defaultValue',
        'addBefore',
        'addAfter',
        'afterStyle',
        'beforeStyle',
        'prefix',
        'suffix',
        'normalize',
        'normalizeTrigger',
        'autoWidth',
    ]);
    var _b = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), inputComputeStyle = _b[0], setInputComputeStyle = _b[1];
    var getKeyboardEvents = (0,_util_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var refInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var refInputMirror = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var refPrevInputWidth = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var maxLength = (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(propMaxLength)
        ? propMaxLength.errorOnly
            ? undefined
            : propMaxLength.length
        : propMaxLength;
    var normalizeHandler = function (type) {
        var handler;
        var normalizeTrigger = props.normalizeTrigger || ['onBlur'];
        if (Array.isArray(normalizeTrigger) &&
            normalizeTrigger.indexOf(type) > -1 &&
            (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .mf)(props.normalize)) {
            handler = props.normalize;
        }
        return handler;
    };
    var _c = (0,_useComposition__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        value: value,
        maxLength: maxLength,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onPressEnter: onPressEnter,
        normalizeHandler: normalizeHandler,
    }), compositionValue = _c.compositionValue, valueChangeHandler = _c.valueChangeHandler, compositionHandler = _c.compositionHandler, keyDownHandler = _c.keyDownHandler, triggerValueChangeCallback = _c.triggerValueChangeCallback;
    var inputClassNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prefixCls, prefixCls && (_a = {},
        _a[prefixCls + "-size-" + size] = size,
        _a[prefixCls + "-" + props.status] = props.status,
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-autowidth"] = autoFitWidth,
        _a), hasParent ? undefined : className);
    var inputProps = __assign(__assign({ 'aria-invalid': props.status === 'error' || undefined }, otherProps), { readOnly: readOnly, maxLength: maxLength, disabled: disabled, placeholder: placeholder, value: compositionValue || value || '', className: inputClassNames, onKeyDown: keyDownHandler, onChange: valueChangeHandler, onCompositionStart: compositionHandler, onCompositionUpdate: compositionHandler, onCompositionEnd: compositionHandler, onBlur: function (e) {
            var _a;
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
            var normalize = normalizeHandler('onBlur');
            normalize && triggerValueChangeCallback(normalize(e.target.value), e);
        } });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
        return {
            dom: refInput.current,
            focus: function () {
                refInput.current && refInput.current.focus && refInput.current.focus();
            },
            blur: function () {
                refInput.current && refInput.current.blur && refInput.current.blur();
            },
        };
    }, []);
    var updateInputWidth = function () {
        if (refInputMirror.current && refInput.current) {
            var width = refInputMirror.current.offsetWidth;
            refInput.current.style.width = width + inputContentWidth + "px";
        }
    };
    // Set the initial width of <input>, and subsequent updates are triggered by ResizeObserver
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (autoFitWidth) {
            if (!(0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(autoFitWidth) || !autoFitWidth.pure) {
                setInputComputeStyle(getStyleFromInput(refInput === null || refInput === void 0 ? void 0 : refInput.current));
            }
            updateInputWidth();
        }
    }, [autoFitWidth]);
    // Here also need placeholder to trigger updateInputWidth after user-input is cleared
    var mirrorValue = inputProps.value || placeholder;
    var handleClear = function (e) {
        if (refInput.current && refInput.current.focus) {
            refInput.current.focus();
        }
        triggerValueChangeCallback('', e);
        onClear && onClear();
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        allowClear ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", __assign({ ref: refInput }, inputProps)),
            !readOnly && !disabled && allowClear && value ? (clearIcon !== undefined ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", __assign({ tabIndex: 0, className: prefixCls + "-clear-icon" }, getKeyboardEvents({ onPressEnter: handleClear }), { onClick: function (e) {
                    e.stopPropagation();
                    handleClear(e);
                }, onMouseDown: function (e) {
                    e.preventDefault();
                } }), clearIcon)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_class_icon_hover__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, __assign({ tabIndex: 0, className: prefixCls + "-clear-icon" }, getKeyboardEvents({ onPressEnter: handleClear }), { onClick: function (e) {
                    e.stopPropagation();
                    handleClear(e);
                } }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconClose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
                // keep focus status
                , { 
                    // keep focus status
                    onMouseDown: function (e) {
                        e.preventDefault();
                    } })))) : null)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", __assign({ ref: refInput }, inputProps, { style: hasParent
                ? {}
                : __assign(__assign({ minWidth: (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(autoFitWidth) ? autoFitWidth.minWidth : undefined, maxWidth: (0,_util_is__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(autoFitWidth) ? autoFitWidth.maxWidth : undefined }, style), ('height' in props ? { height: height } : {})) }))),
        autoFitWidth && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_util_resizeObserver__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { onResize: function () {
                var inputWidth = refInputMirror.current.offsetWidth;
                if (typeof autoFitWidth === 'object') {
                    var delay = typeof autoFitWidth.delay === 'function'
                        ? autoFitWidth.delay(inputWidth, refPrevInputWidth.current)
                        : autoFitWidth.delay;
                    delay ? setTimeout(updateInputWidth, delay) : updateInputWidth();
                }
                else {
                    updateInputWidth();
                }
                refPrevInputWidth.current = inputWidth;
            } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_util_classNames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prefixCls + "-mirror"), style: hasParent
                    ? inputComputeStyle
                    : __assign(__assign(__assign({}, inputComputeStyle), style), ('height' in props ? { height: height } : {})), ref: refInputMirror }, (0,_util_fillNBSP__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(mirrorValue))))));
});
InputComponent.displayName = 'InputComponent';
/* harmony default export */ __webpack_exports__["Z"] = (InputComponent);


/***/ }),

/***/ 36211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useComposition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_keycode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85660);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


// Handle input text like Chinese
function useComposition(_a) {
    var value = _a.value, maxLength = _a.maxLength, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onPressEnter = _a.onPressEnter, beforeTriggerValueChangeCallback = _a.beforeTriggerValueChangeCallback, normalizeHandler = _a.normalizeHandler;
    var refIsComposition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var _b = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), 2), compositionValue = _b[0], setCompositionValue = _b[1];
    var triggerValueChangeCallback = function (newValue, e) {
        if (beforeTriggerValueChangeCallback) {
            beforeTriggerValueChangeCallback(newValue);
        }
        if (onChange &&
            // https://github.com/arco-design/arco-design/issues/520
            // Avoid triggering onChange repeatedly for the same value
            // Compositionend is earlier than onchange in Firefox, different with chrome
            newValue !== value &&
            (maxLength === undefined || newValue.length <= maxLength)) {
            onChange(newValue, e);
        }
    };
    return {
        compositionValue: compositionValue,
        triggerValueChangeCallback: triggerValueChangeCallback,
        compositionHandler: function (e) {
            refIsComposition.current = e.type !== 'compositionend';
            if (!refIsComposition.current) {
                setCompositionValue(undefined);
                triggerValueChangeCallback(e.target.value, e);
            }
        },
        valueChangeHandler: function (e) {
            var newValue = e.target.value;
            if (!refIsComposition.current) {
                compositionValue && setCompositionValue(undefined);
                triggerValueChangeCallback(newValue, e);
            }
            else {
                // https://github.com/arco-design/arco-design/issues/397
                // compositionupdate => onchange
                refIsComposition.current = false;
                setCompositionValue(newValue);
            }
        },
        keyDownHandler: function (e) {
            var keyCode = e.keyCode || e.which;
            if (!refIsComposition.current) {
                onKeyDown && onKeyDown(e);
                if (keyCode === _util_keycode__WEBPACK_IMPORTED_MODULE_1__/* .Enter.code */ .Ce.code) {
                    onPressEnter && onPressEnter(e);
                    var normalize = normalizeHandler === null || normalizeHandler === void 0 ? void 0 : normalizeHandler('onPressEnter');
                    normalize && triggerValueChangeCallback(normalize(e.target.value), e);
                }
            }
        },
    };
}


/***/ }),

/***/ 81682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_InputTag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tag/index.js
var Tag = __webpack_require__(6277);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/input-element.js
var input_element = __webpack_require__(17538);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/getHotkeyHandler.js
var getHotkeyHandler = __webpack_require__(46970);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/Draggable/index.js + 1 modules
var Draggable = __webpack_require__(52030);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/fillNBSP.js
var fillNBSP = __webpack_require__(97931);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputTag/input-tag.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
















var CSS_TRANSITION_DURATION = 300;
var REACT_KEY_FOR_INPUT = "__input_" + Math.random().toFixed(10).slice(2);
// 输入框粘贴会先触发 onPaste 后触发 onChange，但 onChange 的 value 中不包含换行符
// 如果刚刚因为粘贴触发过分词，则 onChange 不再进行分词尝试
var THRESHOLD_TOKEN_SEPARATOR_TRIGGER = 100;
var isEmptyNode = function (node) {
    return node === null || node === undefined;
};
var keepFocus = function (e) {
    e.target.tagName !== 'INPUT' && e.preventDefault();
};
var formatValue = function (value) {
    if (!(0,is/* isArray */.kJ)(value)) {
        return [];
    }
    return value.map(function (item) {
        return (0,is/* isObject */.Kn)(item)
            ? __assign(__assign({}, item), { label: 'label' in item ? item.label : item.value, value: item.value, closable: item.closable }) : {
            label: item,
            value: item,
        };
    });
};
// Deal with the delay of recomputing input width
var useComputeAutoWidthDelay = function (value) {
    var refDelay = (0,react.useRef)(0);
    var refPrevValueLength = (0,react.useRef)(value.length);
    (0,react.useEffect)(function () {
        refDelay.current =
            value.length === 0 && refPrevValueLength.current > 0 ? CSS_TRANSITION_DURATION : 0;
        refPrevValueLength.current = value.length;
    }, [value]);
    return refDelay;
};
var UsedTransitionGroup = function (_a) {
    var prefixCls = _a.prefixCls, children = _a.children, animation = _a.animation;
    return animation ? (react.createElement(TransitionGroup/* default */.Z, { component: "div", className: prefixCls + "-inner" }, children)) : (react.createElement("div", { className: prefixCls + "-inner" }, children));
};
var defaultProps = {
    animation: true,
    validate: function (inputValue, values) { return inputValue && values.every(function (item) { return item.value !== inputValue; }); },
};
function InputTag(baseProps, ref) {
    var _a, _b;
    var _this = this;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, ctxSize = _c.size, componentConfig = _c.componentConfig, rtl = _c.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.InputTag);
    var className = props.className, style = props.style, placeholder = props.placeholder, error = props.error, disabled = props.disabled, readOnly = props.readOnly, allowClear = props.allowClear, autoFocus = props.autoFocus, labelInValue = props.labelInValue, disableInput = props.disableInput, animation = props.animation, saveOnBlur = props.saveOnBlur, dragToSort = props.dragToSort, icon = props.icon, prefix = props.prefix, suffix = props.suffix, addBefore = props.addBefore, addAfter = props.addAfter, tokenSeparators = props.tokenSeparators, validate = props.validate, renderTag = props.renderTag, tagClassName = props.tagClassName, onInputChange = props.onInputChange, onKeyDown = props.onKeyDown, onPaste = props.onPaste, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onRemove = props.onRemove, onClear = props.onClear, onClick = props.onClick, rest = __rest(props, ["className", "style", "placeholder", "error", "disabled", "readOnly", "allowClear", "autoFocus", "labelInValue", "disableInput", "animation", "saveOnBlur", "dragToSort", "icon", "prefix", "suffix", "addBefore", "addAfter", "tokenSeparators", "validate", "renderTag", "tagClassName", "onInputChange", "onKeyDown", "onPaste", "onChange", "onFocus", "onBlur", "onPressEnter", "onRemove", "onClear", "onClick"]);
    var prefixCls = getPrefixCls('input-tag');
    var size = 'size' in props ? props.size : ctxSize;
    var refInput = (0,react.useRef)();
    var refTSLastSeparateTriggered = (0,react.useRef)(null);
    var _d = __read((0,react.useState)(false), 2), focused = _d[0], setFocused = _d[1];
    var _e = __read((0,useMergeValue/* default */.Z)([], {
        defaultValue: 'defaultValue' in props ? formatValue(props.defaultValue) : undefined,
        value: 'value' in props ? formatValue(props.value) : undefined,
    }), 2), value = _e[0], setValue = _e[1];
    var _f = __read((0,useMergeValue/* default */.Z)('', {
        value: props.inputValue,
    }), 2), inputValue = _f[0], setInputValue = _f[1];
    var refDelay = useComputeAutoWidthDelay(value);
    var draggable = !!(dragToSort && !readOnly && !disabled);
    (0,react.useImperativeHandle)(ref, function () {
        var _a, _b;
        return {
            blur: (_a = refInput.current) === null || _a === void 0 ? void 0 : _a.blur,
            focus: (_b = refInput.current) === null || _b === void 0 ? void 0 : _b.focus,
        };
    }, []);
    var valueChangeHandler = function (value, reason) {
        if (disabled || readOnly) {
            return;
        }
        if (!('value' in props)) {
            setValue(value);
        }
        onChange && onChange(labelInValue ? value : value.map(function (x) { return x.value; }), reason);
    };
    var tagCloseHandler = function (itemValue, index, event) {
        onRemove && onRemove(itemValue, index, event);
        valueChangeHandler(__spreadArray(__spreadArray([], __read(value.slice(0, index)), false), __read(value.slice(index + 1)), false), 'remove');
    };
    var hotkeyHandler = (0,getHotkeyHandler/* default */.Z)(new Map([
        [
            keycode/* Backspace.code */.kW.code,
            function (event) {
                if (!event.target.value && value.length) {
                    for (var index = value.length - 1; index >= 0; index--) {
                        var itemValue = value[index];
                        if (itemValue.closable !== false) {
                            tagCloseHandler(itemValue, index, event);
                            return;
                        }
                    }
                }
            },
        ],
    ]));
    var tryAddInputValueToTag = function () { return __awaiter(_this, void 0, void 0, function () {
        var validateResult, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!(typeof validate === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, validate(inputValue, value)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = true;
                    _b.label = 3;
                case 3:
                    validateResult = _a;
                    if (validateResult) {
                        valueChangeHandler(value.concat({
                            value: validateResult === true ? inputValue : validateResult,
                            label: inputValue,
                        }), 'add');
                        setInputValue('');
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var mergedRenderTag = function (item, index) {
        var _a;
        var itemValue = item.value, label = item.label;
        var closable = !readOnly && !disabled && item.closable !== false;
        var onClose = function (event) {
            tagCloseHandler(item, index, event);
        };
        if (renderTag) {
            return renderTag({
                value: itemValue,
                label: label,
                closable: closable,
                onClose: onClose,
            }, index, value);
        }
        return (react.createElement(Tag/* default */.Z, { visible: true, className: (0,classNames/* default */.Z)(prefixCls + "-tag", (_a = {},
                _a[tagClassName] = tagClassName,
                _a)), closable: closable, closeIcon: icon && icon.removeIcon, __closeIconProps: {
                onMouseDown: keepFocus,
            }, title: typeof label === 'string' ? label : undefined, onClose: onClose }, (0,fillNBSP/* default */.Z)(label)));
    };
    var handleTokenSeparators = function (str, isPaste) {
        if (isPaste === void 0) { isPaste = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var splitTextList, validatedValueList_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // won't handle token separators in a short time
                        if (isPaste &&
                            Date.now() - refTSLastSeparateTriggered.current < THRESHOLD_TOKEN_SEPARATOR_TRIGGER) {
                            return [2 /*return*/];
                        }
                        // clear the timestamp, and then we can judge whether tokenSeparators has been triggered
                        // according to timestamp value
                        refTSLastSeparateTriggered.current = null;
                        if (!((0,is/* isArray */.kJ)(tokenSeparators) && tokenSeparators.length)) return [3 /*break*/, 2];
                        splitTextList = str.split(new RegExp("[" + tokenSeparators.join('') + "]"));
                        if (!(splitTextList.length > 1)) return [3 /*break*/, 2];
                        // record the timestamp of tokenSeparators triggered
                        refTSLastSeparateTriggered.current = Date.now();
                        validatedValueList_1 = [];
                        return [4 /*yield*/, Promise.all(splitTextList.map(function (text) { return __awaiter(_this, void 0, void 0, function () {
                                var validateResult, _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            if (!text) return [3 /*break*/, 4];
                                            if (!(typeof validate === 'function')) return [3 /*break*/, 2];
                                            return [4 /*yield*/, validate(text, value)];
                                        case 1:
                                            _b = _c.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            _b = true;
                                            _c.label = 3;
                                        case 3:
                                            _a = _b;
                                            return [3 /*break*/, 5];
                                        case 4:
                                            _a = false;
                                            _c.label = 5;
                                        case 5:
                                            validateResult = _a;
                                            if (validateResult) {
                                                validatedValueList_1.push({
                                                    value: validateResult === true ? text : validateResult,
                                                    label: text,
                                                });
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        if (validatedValueList_1.length) {
                            valueChangeHandler(value.concat(validatedValueList_1), 'add');
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    var clearIcon = allowClear && !disabled && !readOnly && value.length ? (react.createElement(icon_hover/* default */.Z, { size: size, key: "clearIcon", className: prefixCls + "-clear-icon", onClick: function (e) {
            var _a;
            e.stopPropagation();
            valueChangeHandler([], 'clear');
            if (!focused) {
                (_a = refInput.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            onClear && onClear();
        } }, (icon && icon.clearIcon) || react.createElement(IconClose/* default */.Z, null))) : null;
    var disableInputComponent = disabled || disableInput;
    // CSSTransition needs to be a direct child of TransitionGroup, otherwise the animation will NOT work
    // https://github.com/arco-design/arco-design/issues/622
    var childrenWithAnimation = value
        .map(function (x, i) {
        // Check whether two tags have same value. If so, set different key for them to avoid only rendering one tag.
        var isRepeat = value.findIndex(function (item) { return item.value === x.value; }) !== i;
        var eleTag = mergedRenderTag(x, i);
        return react.isValidElement(eleTag) ? (react.createElement(CSSTransition/* default */.Z, { key: typeof x.value === 'object' ? i : isRepeat ? x.value + "-" + i : x.value, timeout: CSS_TRANSITION_DURATION, classNames: "zoomIn" }, eleTag)) : (eleTag);
    })
        .concat(react.createElement(CSSTransition/* default */.Z, { key: REACT_KEY_FOR_INPUT, timeout: CSS_TRANSITION_DURATION, classNames: "zoomIn" },
        react.createElement(input_element/* default */.Z, { autoComplete: "off", size: size, disabled: disableInputComponent, readOnly: readOnly, ref: refInput, autoFocus: autoFocus, placeholder: !value.length ? placeholder : '', prefixCls: prefixCls + "-input", autoFitWidth: {
                delay: function () { return refDelay.current; },
                pure: true,
                minWidth: value.length ? undefined : '100%',
            }, onPressEnter: function (e) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            inputValue && e.preventDefault();
                            onPressEnter === null || onPressEnter === void 0 ? void 0 : onPressEnter(e);
                            return [4 /*yield*/, tryAddInputValueToTag()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onFocus: function (e) {
                if (!disableInputComponent && !readOnly) {
                    setFocused(true);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
                }
            }, onBlur: function (e) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setFocused(false);
                            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                            if (!saveOnBlur) return [3 /*break*/, 2];
                            return [4 /*yield*/, tryAddInputValueToTag()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            setInputValue('');
                            return [2 /*return*/];
                    }
                });
            }); }, value: inputValue, onChange: function (value, event) {
                // Only fire callback on user input to ensure parent component can get real input value on controlled mode.
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value, event);
                var inputType = event.nativeEvent.inputType;
                // do NOT use await, need to update input value right away
                handleTokenSeparators(value, inputType === 'insertFromPaste');
                if (refTSLastSeparateTriggered.current) {
                    setInputValue('');
                }
                else {
                    setInputValue(value);
                }
            }, onKeyDown: function (event) {
                hotkeyHandler(event);
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
            }, onPaste: function (event) {
                onPaste === null || onPaste === void 0 ? void 0 : onPaste(event);
                handleTokenSeparators(event.clipboardData.getData('text'));
            } })));
    var hasPrefix = !isEmptyNode(prefix);
    var hasSuffix = !isEmptyNode(suffix) || !isEmptyNode(clearIcon);
    var needAddBefore = !isEmptyNode(addBefore);
    var needAddAfter = !isEmptyNode(addAfter);
    var needWrapper = needAddBefore || needAddAfter;
    var status = props.status || (error ? 'error' : undefined);
    var innerClassNames = (0,classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-size-" + size] = size,
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-" + status] = status,
        _a[prefixCls + "-focus"] = focused,
        _a[prefixCls + "-readonly"] = readOnly,
        _a[prefixCls + "-has-suffix"] = hasSuffix,
        _a[prefixCls + "-has-placeholder"] = !value.length,
        _a[prefixCls + "-rtl"] = rtl,
        _a));
    var propsAppliedToRoot = { style: style, className: className };
    var eleInputTagCore = (react.createElement("div", __assign({}, (0,omit/* default */.Z)(rest, ['status', 'size', 'defaultValue', 'value', 'inputValue']), (needWrapper ? {} : propsAppliedToRoot), { className: needWrapper ? innerClassNames : (0,classNames/* default */.Z)(innerClassNames, propsAppliedToRoot.className), onMouseDown: function (event) {
            focused && keepFocus(event);
        }, onClick: function (e) {
            var _a;
            !focused && ((_a = refInput.current) === null || _a === void 0 ? void 0 : _a.focus());
            if (onClick) {
                onClick(e);
            }
        } }),
        react.createElement("div", { className: prefixCls + "-view" },
            hasPrefix && (react.createElement("div", { className: prefixCls + "-prefix", onMouseDown: keepFocus }, prefix)),
            draggable ? (react.createElement(UsedTransitionGroup, { key: "transitionGroupWithDrag", prefixCls: prefixCls, animation: animation },
                react.createElement(Draggable/* default */.Z, { itemWrapperStyle: { display: 'inline-block' }, direction: "horizontal", onIndexChange: function (index, prevIndex) {
                        var moveItem = function (arr, fromIndex, toIndex) {
                            arr = arr.slice();
                            var isMoveLeft = fromIndex > toIndex;
                            var _a = __read(arr.splice(fromIndex, 1), 1), item = _a[0];
                            arr.splice(isMoveLeft ? toIndex : toIndex - 1, 0, item);
                            return arr;
                        };
                        valueChangeHandler(moveItem(value, prevIndex, index), 'sort');
                    } }, childrenWithAnimation))) : (react.createElement(UsedTransitionGroup, { prefixCls: prefixCls, animation: animation }, childrenWithAnimation)),
            hasSuffix && (react.createElement("div", { className: prefixCls + "-suffix", onMouseDown: keepFocus },
                clearIcon,
                suffix)))));
    if (!needWrapper) {
        return eleInputTagCore;
    }
    return (react.createElement("div", __assign({}, propsAppliedToRoot, { className: (0,classNames/* default */.Z)(prefixCls + "-wrapper", (_b = {},
            _b[prefixCls + "-wrapper-rtl"] = rtl,
            _b), propsAppliedToRoot.className) }),
        needAddBefore && react.createElement("div", { className: prefixCls + "-addbefore" }, addBefore),
        eleInputTagCore,
        needAddAfter && react.createElement("div", { className: prefixCls + "-addafter" }, addAfter)));
}
var InputTagRef = react.forwardRef(InputTag);
InputTagRef.displayName = 'InputTag';
/* harmony default export */ var input_tag = (InputTagRef);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputTag/index.js

/* harmony default export */ var es_InputTag = (input_tag);


/***/ }),

/***/ 23305:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);